import { Translation } from 'types/language/translation.lang';

export let Nb: Translation = {
  charts: {
    loading: 'Laster data...',
    noData: 'Ingen data å vise',
    a11yNoValue: 'ingen verdi',
    toolbarExport: 'Eksporter',
    toolbarExportPrint: 'Skriv ut',
    toolbarExportImage: 'Eksporter som {type}',
  },
  general: {
    copy: 'Kopiere',
    ok: 'Ok',
    empty: ' ',
    nextFish: 'Neste fisk',
    next: 'Neste',
    back: 'Tilbake',
    update: 'Oppdater',
    save: 'Lagre',
    create: 'Opprett {type}',
    start: 'Start',
    edit: 'Rediger {type}',
    add: 'Legg til {type}',
    submit: 'Lagre {type}',
    reset: 'Reset',
    view: 'Vis',
    close: 'Lukk',
    loading: 'Laster...',
    continue: 'Fortsette',
    delete: 'Slett',
    yesDelete: 'Ja, slett',
    deleteComment: 'Dette kan ikke angres.',
    ignore: 'Ignorer',
    accept: 'Aksepter',
    confirm: 'Bekreft',
    search: 'Søk',
    notApplicable: 'N/A',
    hide: 'Skjul',
    week: 'uke',
    day: 'Dag',
    month: 'Måned',
    date: 'Dato',
    download: 'Nedlast',
    print: 'Print',
    value: 'Verdi',
    chartWeek: 'UKE {row}',
    degrees: 'GRADER',
    exportPDFBtn: 'PDF',
    exportScriptsBtn: 'Exportae Script',
    viewResultBtn: 'Se resultat',
    exportJSONBtn: 'Exportae JSON',
    exportCSVBtn: 'CSV',
    confidential:
      'KONFIDENSIELL. Dette dokumentet inneholder Cargill konfidensiell informasjon. Avsløring, bruk eller reproduksjon utenfor Cargill eller inne i Cargill, til eller av de som ikke trenger å vite det er forbudt. Copyright © Cargill, Incorporated. Alle Rettigheter Reservert.',
    product: 'Produkt',
    site: 'Lokalitet',
    from: 'Fra',
    to: 'Til',
    remove: 'Slett',
    minimize: 'Minimer menyen',
    repeatOrder: 'Gjenta bestilling',
    recalculate: 'Beregn på nytt',
    recalculateIsNeeded: 'Omberegning er nødvendig',
    selectAll: 'Velg alle',
    moreInfo: 'Mer informasjon',
    language: 'Språk',
    locale: 'Locale',
    company: 'Selskap',
    noResults: 'Ingen resultater',
    cancel: 'Avbryt',
    checkAll: 'Velg alle',
    clearFilterLabel: 'Fjern filter',
    multiple: 'Flere valgte',
    release: ' Release',
    clearSelection: 'Fjern valg',
    removeLine: 'Fjern linje',
    addLine: 'Legg til linje',
    previous: 'Forrige',
    pageNotFound: {
      title: 'Siden ble ikke funnet',
      description: 'Siden du leter etter finnes ikke eller har blitt flyttet.',
      goToOverview: 'Gå til Oversikt',
    },
  },
  errorBoundary: {
    retry: 'Prøv igjen',
    title: 'Noe gikk galt',
    message: 'Denne delen er midlertidig utilgjengelig. Prøv igjen.',
  },
  features: {
    overview: 'Oversikt',
    deliveryBoard: 'Delivery Board',
    siteSettings: 'Mine Lokaliteter',
    orderFeed: 'Fôrbestilling',
    bluViuNutrition: 'bluViu Nutrition',
    fishCheck: 'Fish Check',
    profilesStrategies: 'Profiler & Strategier',
    planningPrognosis: 'Plan & Prognose',
    feedManagement: 'Feed Management',
    powerBi: 'PowerBI Rapporter',
    settings: 'Innstillinger',
    seaCloudFileUpload: 'SeaCloud Filopplasting',
    fileSharing: 'Filer',
    shrimpDataUpload: 'Shrimp Data Upload',

    productionSystems: 'Produksjonssystemer',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Selvbetjening',

    playground: 'Playground',
  },
  login: {
    title: 'Innlogging nødvendig',
    loginCustomer: 'Logg inn som kunde',
    loginEmployee: 'Logg inn som Cargill-ansatt',
  },
  selectCompany: {
    intro: 'Du er koblet til flere kunder',
    subtitle: 'Vennligst velg ett av alternativene nedenfor',
  },
  toolbar: {
    changeAccount: {
      customerNumber: 'Kundenr',
      customerName: 'Kundenavn',
      signOut: 'Logg ut',
    },
  },
  overview: {
    dialog: {
      title: 'Hva er bluViu? ',
      readMore: 'Les mer',
      paragraphOne:
        'bluViu er Cargill Aqua Nutrients plattform for å levere digitale tjenester, analyser, innsikter, optimalisering og transformasjon til akvaindustrien globalt. ',
      paragraphTwo: 'Vårt oppdrag er å muliggjøre en mer bærekraftig, profitabel akvakultur for fremtiden.',
      paragraphThree:
        'bluViu er 100% eiet og utviklet av Cargill, av et dedikert team. Vi jobber kontinuerlig med å bygge relevante løsninger, som gjør oss til en foretrukket partner for ledende selskaper innen akvakultur. Vi integrerer datastrommer fra leverandører og kunder, teknologileverandører, og samarbeider med våre partnere om å bygge nye innsikter og muligheter.',
      paragraphFour:
        'Vi ser frem til å utvikle dette økosystemet sammen med ledende selskaper innen akvakultur! Hvis du er interessert i å finne ut mer, ta kontakt gjennom din Cargill kontaktperson. ',
      yourSites: 'Din lokaliteter',
    },
    etaHeader: 'Ordre ETA',
    loading: 'Laster Ordre ETA',
    noEtaFound: 'Ingen  ETA I systemet ',
    onTheWay: 'Er på vei, ETA: ',
    notifications: 'Varsler',
    noNotificationsFound: 'Ingen varsler',
  },
  deliveryBoard: {
    showFactories: 'Vis fabrikker',
    columns: {
      loading: 'Lastes',
      onRoute: 'Underveis',
      delivered: 'Levert',
      columns: 'Kolonner',
      map: 'Kart',
      sites: 'Lokaliteter',
      alert: {
        disclaimer:
          'Delivery board er i betatesting - vi setter pris på dine tilbakemeldinger, og ber om forståelse for at denne delen av plattformen ennå er under utvikling - så vi kan oppleve ustabilitet, feil og lignende.',
      },
    },
    card: {
      dispatchDate: 'Lastedato:',
      editDistribution: 'Rediger fordeling',
      readyToDistribute: 'Klar til fordeling',
      distribute: 'Silofordeling',
      edit: 'Rediger',
      product: 'Produkt',
      quantity: 'Mengde',
      viewOrder: 'Se bestilling',
      contactVessel: 'Kontakt til fartøy',
      deliveryNotes: 'Leveringsdokument',
      deliveryDocuments: 'Leveringsdokument',
      delayed: 'Forsinket',
      eta: 'ETA',
    },
  },
  settings: {
    name: 'Navn',
    phone: 'Telefon',
    email: 'e-post',
    marketContacts: 'Markedskontakter',
    marketContactsText: 'Hvis du har spørsmål, kan du kontakte ordrekontoret eller kontaktpersonen din hos Cargill.',
    cargillContact: 'Cargill kontaktperson',
    needHelp: 'Trenger du hjelp?',
    weather: 'Vær',
    snowToggle: 'La det snø!',
    snowHint: 'Hint: Du kan også skrive "jul" når som helst for å slå snøeffekten av eller på!',
  },
  siteSettings: {
    navigation: {
      listSites: 'Lokalitet',
      generalSettings: 'General Settings',
      inventorySiloManagement: 'Beholdning & Siloadministrasjon',
      contactDetails: 'Kontaktinformasjon',
    },
    view: {
      goToSite: 'Gå til lokalitetet',
    },
    listSites: {
      title: 'Innstillinger',
      introText: 'Innstillinger for lokaliteter.',
      sitesLabel: 'Sites ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      sitesWithoutErpIdLabel: 'Other sites ({value})',
      list: {
        noResults: 'Ingen resultater',
        site: 'Lokalitet',
        status: 'Status',
        siteErpIdLabel: 'Site ERP ID',
        ofdEnabledLabel: 'OFD',
        automaticOrderingLabel: 'Automatic Ordering',
        ascLabel: 'ASC',
      },
    },
    viewSiteSettings: {
      silos: 'Silos',
      totalMaxCap: 'Total max kapasitet, kg',
      numberOfFish: 'Antall fisk',
      averageWeight: 'Gjennomsnittsvekt, g',
    },
    editSiteSettings: {
      title: 'Lokalitet Innstillinger for {name}',
      alert: 'Vennligst kalibrer lokalitetet på nytt',
      emails: 'E-poster',
      phoneNumbers: 'Telefonnummer',
      siloCapacity: {
        title: 'Silo Innstillinger',
        siloSiteInventory: 'Silo Site Inventory',
        siloCapacityLabel: 'Silo Kapasitet',
        useFallbackData: 'Bruk reservedata',
        siloFeedQuantityDateLabel: 'Silo fôrkvantum dato',
        siloFeedQuantityLabel: 'Silo fôrkvantum',
        dialog: {
          button: 'Endre Silo Innstillinger',
          title: 'Endre Silo Innstillinger',
          siloCapacityLabel: 'Max Silo Kapasitet',
          siloInventoryUpdatedLabel: 'Fôrkvantum dato',
          siloCurrentInventoryLabel: 'Fôrkvantum',
        },
      },
      siloManagement: {
        title: 'Siloadministrasjon',
        siloName: 'Silo navn',
        maxCapacity: 'Silokapasitet',
        fleetName: 'Fleet Name',
        description: 'Description',
        capacity: 'Capacity',
        disabled: 'Disabled?',
      },
      siloFillPercentage: {
        title: 'Silo fyll buffer',
        dialog: {
          warning: 'Eksisterende bestillinger vil bli endret',
          title: 'Endre silo buffer',
          button: 'Endre silo buffer',
          capacityBufferPercentage: 'Statisk kapasitetsbuffer',
          refillSiloToLabel: 'Fyll silo til',
          setInventoryBufferLabel: 'Bruk Static Silo Refill',
          dynamicConsumptionBuffer: 'Dynamisk forbruksbuffer',
        },
      },
      siteComment: {
        inputLabel: 'Kommentar om lokalitet',
        headingLabel: 'Denne informasjonen vil bli sendt til fartøyet med hvert silo fordeling',
        title: 'Informasjon om lokalitet (beregnet for fartøy)',
        editButton: 'Redigere',
      },
      longitudeLatitude: {
        title: 'Lengde- og breddegrad',
        latitudeLabel: 'Breddegrad',
        longitudeLabel: 'Lengegrad',
        dialog: {
          button: 'Endre plassering',
          title: 'Endre Lengde- og breddegrad',
          latitudeLabel: 'Breddegrad',
          longitudeLabel: 'Lengdegrad',
        },
      },
      temperatureProfile: {
        title: 'Temperaturprofil',
        selectYears: 'Velg år',
        temperatureDialog: {
          title: 'Opprett temperaturprofi',
          subTitle: 'Gjennomsnittlig temperatur',
          graph: 'Graph',
          list: 'List',
        },
      },
      calibrationFeedProgram: {
        dialog: {
          title: 'Edit Feed Program',
          button: 'Edit Feed Program',
        },
      },
      calibration: {
        title: 'Calibration',
        subTitle: 'Calibration inputs',
        isCalibrationCalculatedLabel: 'Is Calibration Calculated',
        hasFeedProgramsLabel: 'Has Feed Programs',
        runButton: 'Run Calibration',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        list: {
          fishSizeStartLabel: 'Fish size start(g)',
          feedIdLabel: 'Feed',
          feedAxMgPerKgLabel: 'Feed ax, mg/kg',
          feedMaizeGlutenPercentLabel: 'Feed maize gluten,(%)',
          relativeMortalityImpactLabel: 'Relative mortality impact',
          relativeGrowthImpactLabel: 'Relative growth impact',
          salmonPricePremiumPerKgGuttedLabel: 'Price premium /kg gutted',
          formulationCostPerTonLabel: 'Formulation Cost /ton',
          customerPricePerTonLabel: 'Customer Price /ton',
        },
        dialog: {
          button: 'Edit Inputs',
          name: 'Navn',
          title: 'Edit Calibration',
          stockingFishWeightGLabel: 'Stocking Fish Weight',
          stockingDateLabel: 'Stocking Date',
          harvestFishWeightGLabel: 'Harvest Fish Weight',
          harvestDateLabel: 'Harvest Date',
          harvestCyclebFCRLabel: 'Harvest Cycle bFCR',
          stockingFishWeightErrorLabel: 'Stocking weight cannot be higher than harvest weight',
        },
        warningMessage: {
          caption: 'To enable the inputs and be able to run a calibration please ensure that:',
          reasonOne: 'Site has latitude and longitude configured',
          reasonTwo: 'Site has temperature profile set',
          reasonThree: 'Contact an admin to make sure the site has the correct mappings',
        },
      },
      recommendedProducts: {
        title: 'Anbefalte produkter',
        noResults: 'Ingen produkter funnet',
        product: {
          productName: 'Produktnavn',
          expirationDate: 'Anbefalingens utløpsdato',
        },
        dialog: {
          title: 'Endre anbefalte produkter',
          button: 'Endre',
        },
      },
      orderFreeDelivery: {
        title: 'Ordrefri levering',
      },
    },
  },
  orderFeed: {
    asc: 'ASC',
    navigation: {
      orderSupplyPlan: 'Min leveranseplan',
      orderDistribution: 'Fordeling',
      orderHistory: 'Ordrehistorikk',
      createOrder: 'Opprett tilpasset ordre',
      listStarvation: 'Sulting',
      purchaseHistory: 'Kjøpsrapport',
      timeline: 'Tidslinje',
    },
    alert: {
      maintenance: 'Bestilling er nede grunnet planlagt vedlikehold',
      endsAt: 'Slutter kl: ',
      duplicate: 'En eller flere ordrelinjer er identiske',
      duplicateLine: 'Denne linjen er identisk med en annen linje i bestillingen.',
      shippingSchedule: 'Skipningsdato ikke lenger tilgjengelig',
      productDateRange: 'Produktet finnes ikke lenger i prislisten for den valgte forsendelsesdatoen',
    },
    ofdMySupplyPlan: {
      ordersLabel: 'Ordrer',
      inputSettingsLabel: 'Innstillinger',
      ofdActive: 'OFD (Ordrefri levering) aktiv',
      settingsUnavailableTitle: 'OFD settings are temporarily unavailable',
      settingsUnavailableMessage: 'We could not load OFD settings right now. You can retry, or continue using the rest of the page.',
      retrySettingsFetch: 'Retry',
      viewTemporarilyUnavailable: 'This section is temporarily unavailable',
      recoverView: 'Recover view',
      todayLabel: 'I dag',
      dayOfNextDelivery: 'Dag for neste levering',
      tooltipContent: 'Forventet lager i løpet av ',
      cards: {
        startingInventory: 'Startbeholdning',
        consumptionRate: 'Forbruksrate',
        consumption: 'Forbruk',
        orderDelivered: 'Ordre levert',
        status: 'Trenger manuell oppdatering',
        capacity: 'av kapasitet',
        day: '/ dag',
        runOut: 'Når lageret forventes å gå tomt:',
        nextDeliveryNoDate: 'Ingen dato tilgjengelig',
        contactCustomerService: 'Kontakt kundeservice',
        lowInventory: 'Lavt lager!',
        endingInventory: 'Sluttbeholdning',
        confirmedDelivery: 'Bekreftet levering:',
        forecastedDelivery: 'Prognostisert levering:',
        buttons: {
          openInventory: 'Åpne lager',
          openConsumption: 'Åpne forbruk',
        },
        drawer: {
          feedInventory: 'Fôrlager',
          calculateConsumption: 'Administrer din beregnede forbruksrate for å holde den nøyaktig.',
          dailyConsumptionRate: 'Daglig forbruksrate',
        },
        orderStatusInfo: {
          days: 'dager',
          day: 'dag',
          forecast: {
            forecastQuestionTitle: 'Hvorfor ble denne ordren generert?',
            forecastAnswerContent:
              'Basert på ditt nåværende lager på {stock} kg og forbruksrate, prognostiserer vi en levering på {units} kg fôr for å opprettholde lageret over bufferen.',
            forecastChangesToOrderTitle: 'Dato for automatisk bekreftelse',
            forecastChangesToOrderContent: {
              bold: 'Vi sender ut en bekreftelse når ordren er bekreftet.',
              message:
                '{date} ({daysLeft} {daysLeftText} igjen - {daysBeforeDispatch} {daysBeforeText} før utsendelse) {br}{br} Ordren vil automatisk justeres frem til da for å opprettholde nøyaktighet.',
            },
          },
          skipped: {
            skippedQuestionTitle: 'Hvorfor ble denne ordren hoppet over?',
            skippedAnswerContent:
              'Basert på lageret ditt, prognostiserer vi at du ikke trenger fôr levert på denne forsendelsen, fordi du har tilstrekkelig lager til å være over buffer til neste forsendelse.',
          },
          open: {
            openQuestionTitle: 'Hvorfor er dette en åpen plass?',
            openAnswerContent:
              'Vi tillater ikke prognostiserte ordrer mellom bekreftede ordrer. {br} Du kan fortsatt opprette en ny ordre på denne tilgjengelige utsendelsesdatoen.',
            cannotCreateOrderQuestion: 'Hvorfor er knappen deaktivert?',
            cannotCreateOrderAnswer:
              'Systemet har ikke generert en ordre for denne forsendelsen. Det er nå forbi fristen for automatisk ordreoppretting. Vennligst kontakt kundeservice hvis du ikke selv kan opprette en ordre på denne forsendelsen.',
          },
          confirmed: {
            changesTitle: 'Endringer i ordre',
            changesContent:
              'Siste dag for å gjøre endringer: {date} ({daysLeft} dager igjen). {br} Etter dette vil ingen endringer være mulig.',
            orderCommentTitle: 'Ordrekommentar',
          },
        },
      },
      sitesLabel: 'Lokasjoner ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      orders: {
        totalOrderQuantity: 'Total Order quantity',
        orderQuantity: 'Order Quantity',
        dispatchDate: 'Dispatch Date',
        selectProduct: 'Select Product',
        methodOfDelivery: 'Method Of Delivery',
        removeOrderLine: 'Remove Order Line',
        addOrderLine: 'Add Order Line',
        customerReference: 'Customer Reference Number',
        orderComment: 'Order Comment',
        orderDetails: 'Order Details (optional)',
        distributionDetails: {
          title: 'Ordre #{orderNumber} - Fordelingsdetaljer',
          showTooltip: 'Vis fordelingsdetaljer',
          showDistribution: 'Vis fordeling',
          updatedAt: 'Oppdatert',
          updatedBy: 'Oppdatert av',
          extraStorage: 'Ikke til silo',
          product: 'Produkt',
          itemNumber: 'Artikkelnummer',
          quantity: 'Kvantum',
          silo: 'Silo',
        },
        availableProducts: 'Show Available Products',
        preferredProducts: 'Show Preferred Products',
        modals: {
          forecastDialog: {
            title: 'Forecasted',
            quantityMessage:
              'This quantity will continiously change and adapt to your supply until confirmed, in order to provide the most accurate forecasts.',
            overridingMessage: 'By overriding this forecast you will be taking manual control of all orders up until {date}.',
            existingForecastMessage: 'We never make forecasts between existing orders.',
            remainingForecastMessage: 'All remaining forecasted orders will automatically be adjusted to fit your changes.',
            calibrateMessage: 'We always recommend you to {calibrate} before changing an order for most accurate forecasts.',
            calibrateSettings: 'calibrate your settings',
            overrideButton: 'Override and create order',
          },
          confirmedDialog: {
            title: 'Confirmed',
            updateButton: 'Update',
            deleteButton: 'Delete order',
            skipButton: 'Skip this dispatch',
            unSkipButton: 'Confirm',
            message: 'We always recommend you to {underlined} before changing an order for most accurate forecasts.',
            underlinedMessage: 'callibrate your settings',
            deleteOrder: {
              deletionReason: 'Select the deletion reason',
              deleteOrderMessage: 'Are you sure that you want to delete this order?',
            },
            skipRecommendation: {
              skipRecommendationConfirmationMessage: 'Are you sure that you want to skip this dispatch date ({date})?',
              unSkipRecommendationMessage: 'Are you sure that you want to un-skip this dispatch date ({date})?',
              tooltipLabel:
                'Un-skip this manually skipped dispatch date. Once un-skipped, the system might come up with an order forecast for this date.',
            },
          },
          openDialog: {
            title: 'Open Slot',
          },
          skippedDialog: {
            title: 'Skipped ({type})',
          },
          viewFeedProgramsDialog: {
            viewFeedProgramsBtn: 'View feed programs',
            noFeedStrategyAssigned: 'No feed strategy assigned.',
            columns: {
              fishGroup: 'Fish group',
              latestWeight: 'Latest weight',
              feedProgram: 'Feed program',
              harvestTarget: 'Harvest target',
            },
            options: {
              transferWeights: 'Transfer weights',
              feeds: 'Feeds',
            },
          },
        },
        filters: {
          confirmed: 'Confirmed',
          forecast: 'Forecast',
          skipped: 'Skipped',
        },
        list: {
          delivered: 'Levert',
          orderStatus: 'Order status',
          orderNumber: 'Ordrenummer',
          customerOrderReference: 'Kundens referansenummer',
          autoConfirm: 'Auto-confirm',
          dispatchDate: 'Dispatch date',
          deliveryDate: 'Delivery date',
          quantity: 'Quantity',
          changes: 'Changes?',
          notPossible: 'Not possible',
          days: '{days} days',
          day: '{days} day',
          today: 'Today',
          skipped: 'Skipped ({type})',
          forecast: 'Forecast',
          createOrderBtn: 'Opprett ordre',
          createNewOrderBtn: 'Opprett ordre',
          adjustSettings: 'Adjust settings',
          overrideForecastBtn: 'Override forecast',
          unskipBtn: 'Un-skip',
          manual: 'Manual',
          forecasts: 'Forecasts',
          vesselName: 'Vessel',
          plantName: 'Loading plant',
          orderDetails: 'Order details',
          arrivalDate: 'Arrival date',
          arrivalTime: 'Arrival time',
          orderCreationDate: 'Order creation date',
          body: {
            product: 'Product',
            quantityTitle:
              'This quantity will continiously change and adapt to your supply until confirmed, in order to provide the most accurate forecasts.',
            titleQuestion: 'Quantity not matching up with your plan?',
            messageAnswer:
              'We recommend to recalibrate your settings before making changes to OFD forecasts, in order to improve accuracy.',
            productNotAvailable: 'Product not available',
            productNotAvailableMessage: '- Product not available.',
            productNotAvailableTooltipMessage: 'Contact customer support to add it or add a different feed.',
          },
          productsUnavailableAtPlantTitle: 'Products unavailable at plant',
          productsUnavailableAtPlantMessage:
            'The following products are not included in the recommendations because no plant on your shipping schedule can supply them:',
          productsUnavailableAtPlantInstruction: 'Contact customer support to arrange supply.',
          productsUnavailableAtPlantShow: 'Show {count} products',
          productsUnavailableAtPlantHide: 'Hide products',
        },
      },
      feedInventory: {
        tooltip: {
          events: {
            delivery: 'Delivery',
            forecast: 'Forecast',
            manualUpdate: 'Manual update',
            consumption: 'Consumption',
            expectedConsumption: 'Exp. Consumption',
          },
        },
      },
      inputSettings: {
        feedInventoryTab: {
          label: 'Feed inventory',
          headerText: 'Update your inventory every 90 days in order to receive most accurate feed forecast.',
          lastUpdated: 'Last manual update: ',
          inventoryLevelLabel: 'Enter your latest measured inventory level ',
          inventoryLevelNoDeliveryLabel: 'Enter today’s starting inventory level ',
          feedingStatusLabel: 'When was the inventory measured?',
          feedingStatusDiscloser: '(You have an expected delivery today)',
          confirmedDeliveryLabel: 'Estimated addition based on delivery: ',
          finalCalculatedLabel: 'Final calculated inventory at end of day based on input: ',
          estimatedSubtractionLabel: 'Estimated subtraction based current consumption rate:',
          estimatedSubtractionNoDeliveryLabel: 'Estimated subtraction today based current consumption rate:',
          beforeDelivery: 'Before delivery',
          afterDelivery: 'After delivery',
          daysAgo: 'days ago',
          percentage: '({percentage} of capacity)',
          dialog: {
            title: 'How was this calculated?',
            explanation:
              'Since the last inventory update, several events have impacted your current stock level. Below is a detailed log showing exactly how we arrived at the current inventory figure.',
            log: {
              title: 'Inventory log',
              day: 'Day',
              dataInput: 'Data input',
              event: 'Event',
              adjustment: 'Adjustment',
              startInventory: ' Start inventory',
              today: 'Today’s starting inventory',
              emptyArray: 'Starting inventory',
            },
          },
        },
        dailyConsumptionRateTab: {
          label: 'Daily Consumption Rate',
          headerText: 'Manage your calculated consumption rate to keep it accurate.',
          day: '/day',
          days: 'days',
          recommended: 'Historical average (Recommended)',
          manual: 'Manual adjustment (Not recommended) ',
          sealice: 'Sea lice treatment mode',
          sealiceTooltip: 'Historical average excluding starvation days due to sea lice treatment',
          calculationMethod: 'Calculation method: ',
          prognosis: 'EGI prognosis (today)',
          daysHistoricalAverage: 'Days used as historical average:',
          sliderTitle: 'Percentage offset',
          selectedCalculationLabel: 'Select calculation method',
          tooltipInfo:
            'The base forecast can be adjusted either by a percentage you set, or a percentage we calculate based on consumption average.',
          tooltipMethod:
            'Your average consumption, and our prediction model are compared, and we use the actual consumption to adjust the forecast up or down for the next 45 days.',
          tooltipPrognosis:
            'Your forecast, before adjustment, and how many days we are averaging to adjust the model. Shorter time=more responsive, longer time=more stable.',
          editRecommended: {
            historicalAverage: 'Historical average',
            sliderHeader: 'Select amount of past days to use as average for calculation (3-30 days):',
            title: 'Days',
          },
          editPrognosis: {
            prognosis: 'Manual adjustment',
            alert:
              'You have now switched from the recommended calculation. This will likely be less accurate and needs to be revisited.',
            sliderHeader: 'Adjust prognosis by setting a percentage offset:',
          },
          feedStrategyList: {
            title: 'View Feed Strategy',
            fromWeightLabel: 'From Weight',
            nameLabel: 'Product Name',
            editBtn: 'Edit Feed Strategy',
          },
        },
        feedReserveTab: {
          label: 'Feed Reserve',
          headerText:
            'In case of order delay, feed reserve will aim to keep your desired amount of feed in the inventory at all times.',
          adaptiveBufferTitel: 'Adaptive buffer',
          adaptiveBuffer: 'Adaptive',
          daysConsumption: 'days consumption',
          totalBufferText: 'Based on: Adaptive buffer + Static buffer',
          totalBufferTitel: 'Total buffer',
          adaptiveBufferText: 'Based on your current consumption, {days} days worth of feed equals {increasedDays}.',
          staticBuffer: 'Static buffer',
          staticTitleBuffer: 'Static',
          additionalBufferText: 'Adds an additional amount of feed to your feed reserve as a margin to the adaptive buffer.',
          maxCapacity: 'Max capacity: ',
          days: 'Days',
        },
        preferencesTab: {
          label: 'Preferences',
          headerText: 'Manage your general preferences for the OFD system.',
          minimumQuantityTitle: 'Minimum Forecasted Order Quantity',
          orderFrequency: 'Order Frequency',
          minimumQuantityText:
            'No orders will be placed with volume smaller than this. The site will be supplied with fewer and larger orders.',
          minimumQuantity: 'Minimum quantity',
          minimumOrderFrequencyText: 'It must be a number in the range 1-30',
          minimumOrderFrequency: 'Order Frequency',
          quantityErrorMessage: 'Quantity must be a multiple of {value}',
          minimumValueErrorMessage: '{label} must be at least {minValue}',
          rangeValueErrorMessage: 'Frequency must be between 1 and 30',
        },
      },
      timeline: {
        fortyFiveDays: '45 days',
        twentyOneDays: '21 days',
      },
    },
    listOrderSupplyPlan: {
      title: 'Min leveranseplan',
      filter: {
        siteLabel: 'Velg lokalitet',
        sitesLabel: 'Velg lokaliteter',
        fromDateLabel: 'Fra dato',
        toDateLabel: 'Til dato',
        options: {
          isOfdEnabled: 'OFD enabled',
          noSiloData: 'Mangler silodata',
          noErpAddress: 'Mangler ERP kobling',
        },
      },
      siteList: {
        active: 'Lokaliteter',
        inactive: 'Inaktive lokaliteter',
        noResults: 'Finner ingen lokalitet',
        siteNameLabel: 'Lokalitet',
        nextOrderLabel: 'Neste ordre',
        thirtyDaysPlan: '30 dagers plan',
        inventoryLabel: 'Inventory',
        ofdLabel: 'OFD',
        ofdEnabledTooltip: 'OFD {ofdVersion} er aktivert for denne lokaliteten',
        ofdAutomaticOrderingTooltip: 'OFD {ofdVersion} og automatisk bestilling er aktivert for denne lokaliteten',
        siteIntensityLabel: 'Site intensity',
        supplyWeekLabel: 'Supply wk {weekValue}',
        weekConsumptionLabel: 'Weekly Consump.',
        requireActionLabel: 'Requires action',
        scheduleTooShort: 'Schedule too short',
        productNotAvailable: 'Product not available',
        inventoryUpdateTooltip: 'This site may require additional attention',
      },
      orderList: {
        recommendation: 'Foreslått',
        noResults: 'Ingen ordre funnet',
        orderNumberLabel: 'Ordrenummer',
        customerOrderReferenceLabel: 'Kundens referansenummer',
        requestedDeliveryDateLabel: 'Skipningsdato',
        totalOrderQtyLabel: 'Ordre kvantum',
        productLabel: 'Produkt',
        quantityLabel: 'Kvantum',
        orderedLabel: 'Bestilt',
        amountLabel: 'Mengde',
        changePossibleLabel: 'Endring mulig?',
        noChangeableLabel: 'Nei',
        remainingDaysLabel: 'dager igjen',
        remainingDayLabel: 'dag igjen',
        createOrder: {
          availableProductsGroup: 'Tilgjengelige produkter',
          preferredProductsGroup: 'Anbefalte produkter',
          customerReference: 'Kundens referansenummer',
          methodOfDelivery: 'Leveransemetode',
          orderComment: 'Kommentar til ordre',
          removeOrderLine: 'Slett ordrelinje',
          addOrderLine: 'Legg til ordrelinje',
          editOrderDetails: 'Endre ordredetaljer',
          productDescription: '{type}, emballasje: {packaging}',
          orderCreated: 'Bestilling opprettet',
        },
      },
      statusList: {
        products: {
          withoutAssortmentLabel: 'Produkter ikke tilgjengelig i kundesortiment',
          withoutDensityLabel: 'Produkter uten tetthet',
          correctiveActionLabel: 'Korrigerende tiltak',
        },
        correctiveActions: {
          fixProductDensity: 'Ingen tetthet oppgitt for valgt produkt - ta kontakt med Cargill',
          fixCustomerAssortment: 'Anbefalt fôrtype er ikke tilgjengelig i prisliste (SAP)',
          fixSiloSensor: 'Silosensor sender ikke data',
          fixSiteLinkToErp: 'Lokalitet mangler kobling til SAP',
          fixManuallySpecifiedSiloInventory: 'Silo beholdning må oppdateres manuelt',
          specifySiteSiloInventory: 'Spesifiser silokapasitet og beholdning',
          general: 'Ukjent feil - ta kontakt Cargill',
          enableOrderFreeDelivery: 'Aktiver OFD for lokaliteten',
        },
      },
      createOrderDialog: {
        title: 'Opprett ordre',
        recommendedTitle: 'Opprett anbefalt bestilling',
        methodOfDeliveryLabel: 'Leveringsmetode',
        customerOrderNumberLabel: 'Referansenummer',
        orderCommentLabel: 'Ordrekommentar',
      },
    },
    orderDistribution: {
      filter: {
        fromDateLabel: 'Fra dato',
        toDateLabel: 'Til dato',
      },
      infoText: 'OBS: Silo distribuering stenger 3 timer før båtens ankomst til lokalitet',
      distribute: 'Fordeling',
      readyForDistribution: 'Klar til fordeling',
      distributed: 'Fordelt',
      list: {
        siteName: 'Lokalitet',
        dispatchDate: 'Lastedato',
        deliveryDate: 'Leveringsdato',
        orderQuantity: 'Ordrekvantum',
        editDisabled: 'Det er ikke lenger mulig å endre silofordelingen. Ta direkte kontakt med båten for endringer.',
        vesselName: 'Leveransemetoden',
        configHasChanged: 'The settings for this distribution has changed',
        body: {
          orderNumber: 'Ordrenummer',
          quantity: 'Kvantum',
          distributedQuantity: 'Distributed quantity',
          productName: 'Produktnavn',
          siloName: 'Silonavn',
        },
      },
      createDistribution: {
        infoText: 'OBS: Silo distribuering stenger 3 timer før båtens ankomst til lokalitet',
        distribute: 'Fordeling',
        capacityAlert: 'Kvantum overstiger silokapasitet',
        productAlert: 'Fordeling overstiger kvantum på ordre',
        product: 'Produkt',
        quantity: 'Ordrekvantum',
        additionalNotes: 'Melding til båt',
        comments: 'Fast melding til båt',
        editable: 'Kan redigeres fra "Mine lokaliteter"',
        overview: {
          list: {
            siteName: 'Lokalitet',
            dispatchDate: 'Lastedato',
            deliveryDate: 'Leveringsdato',
            orderQuantity: 'Ordrekvantum',
            body: {
              product: 'Produkt',
              ordered: 'Ordrekvantum',
              toDistribute: 'Tilgjengelig',
              distributed: 'Fordelt',
            },
          },
        },
        form: {
          extraStorage: 'Ikke til silo',
          pointOfContact: 'Kontakt',
          comments: 'Melding til båt',
          removeLine: 'Fjern linje',
          addLine: 'Legg til linje',
          quantity: 'Ordrekvantum',
          product: 'Produkt',
          maxCapacity: 'Kapasitet',
          configHasChanged: 'The settings for this silo has changed',
        },
      },
    },
    orderHistory: {
      title: 'Ordrehistorikk',
      search: 'Ordrenummer',
      dateRange: 'Ordredato fra {fromDate} til {toDate}',
      ordersList: {
        noResults: 'Ingen ordre funnet',
        orderNumberLabel: 'Ordrenummer',
        siteName: 'Lokalitet',
        orderDateLabel: 'Ordredato',
        dispatchDate: 'Skipningsdato',
        status: 'Status',
        orderedQuantity: 'Ordrekvantum',
        invoicedQuantity: 'Fakturakvantum',
        deliveredQuantity: 'Levertkvantum',
        deliveryMethod: 'Leveransemetode',
        product: 'Produktnavn',
        articleNumber: 'Artikkelnummer',
        lineNumber: 'Linjenummer',
        deliveryDateLabel: 'Skipningsdato',
        totalOrderQtyLabel: 'Kvantum',
        deliveryDocuments: 'Delivery notification documents',
        deliveryNotes: 'Leveringsdokument',
      },
      filters: {
        fromDateLabel: 'Fra dato',
        toDateLabel: 'Til dato',
        monthView: 'Periode',
        pastMonth: 'Siste måned',
        pastThreeMonth: 'Siste tre måneder',
        pastSixMonth: 'Siste seks måneder',
        siteLabel: 'Velg lokalitet',
        total: 'Total',
        allSites: 'Velg alle',
        clearSites: 'Tøm utvalg',
      },
    },
    purchaseHistory: {
      title: 'Kjøpsrapport',
      chartTitle: 'Fordeling av produktmengde',
      chartQuantity: 'Total produktmengde',
      groupType: 'Visning',
      product: 'Produkt',
      family: 'Produktgruppe',
      noResults: 'Ingen resultater',

      monthView: 'Periode',
      pastMonth: 'Siste måned',
      pastThreeMonth: 'Siste tre måneder',
      pastSixMonth: 'Siste seks måneder',
      siteLabel: 'Velg lokalitet',
      total: 'Total',
      allSites: 'Velg alle',
      clearSites: 'Tøm utvalg',
    },
    viewOrder: {
      title: 'Ordre #{orderNumber}',
      contactBtn: 'Kontakt oss',
      changeableStatusClosed: 'Denne ordren er lukket for endringer',
      changeableStatusOpen: 'Denne ordren er åpen for endringer frem til {date}',
      deliveryNotes: 'Leveringsdokument',
      deliveryDocuments: 'Delivery notification documents',
      orderHistory: {
        updatedByLabel: 'Updated By',
        updatedAtLabel: 'Updated At',
        orderNumberLabel: 'Order Number',
        title: 'Silo distribution',
        siloNameLabel: 'Silo name',
        itemNameLabel: 'Item name',
        itemNumberLabel: 'Item number',
        quantityLabel: 'Quantity',
      },
      orderLinesList: {
        title: 'Bestilt',
        itemNameLabel: 'Produkt:',
        itemNumberLabel: 'No.',
        requestedDispatchDateLabel: 'Skipningsdato',
        orderQuantityLabel: 'Kvantum',
        repeatOrderBtn: 'Gjenta bestilling',
      },
      orderDeliveriesList: {
        itemNumberLabel: 'Produkt',
        orderQuantityLabel: 'Kvantum:',
      },
      orderInfo: {
        title: 'Ordre informasjon:',
        orderNumberLabel: 'Ordre No:',
        orderDateLabel: 'Ordredato',
        requestedDeliveryDateLabel: 'Foretrukket skipningsdato: ',
        customersOrderNumberLabel: 'Referansenummer',
        orderCommentsLabel: 'Kommentar',
        asc: 'ASC',
        yes: 'Yes',
      },
      invoiceInfo: {
        title: 'Fakturainformasjon',
        customerNameLabel: 'Kundenavn',
        customerNoLabel: 'Kundenummer',
        invoiceNumberLabel: 'Fakturanummer',
      },
      deliveryInfo: {
        title: 'Leveranseinformasjon ',
        transportCompanyNameLabel: 'Leveransemetode:',
        deliveryDateLabel: 'Skipningsdato',
        warehouseNameLabel: 'Levert fra:',
        address1Label: 'Levert til:',
        statusLabel: 'Status',
        etaLabelLabel: 'ETA:',
        orderStatus: {
          received: 'Mottatt',
          confirmed: 'Bekreftet',
          delivered: 'Levert',
          invoiced: 'Fakturert',
          canceled: 'Kansellert',
          unknown: 'Ukjent',
        },
      },
      productDeclaration: {
        title: 'Varedeklarasjon ',
        productNumber: 'Produktnummer: ',
        produced: 'Produsert: ',
        bestBefore: 'Best før: ',
        series: 'Serie: ',
        customer: 'Kunde: ',
        orderNumber: 'Ordrenummer: ',
        deliveredQuantity: 'Levert mengde: ',
        producer: 'Produsent: ',
        producedBy: 'Produsert av: ',
        designation: 'Betegnelse: ',
        instruction: 'Instruksjon: ',
        analyticalComponents: 'Analytiske komponenter: ',
        additives: 'Tilsetningsstoffer, per kg: ',
        vitamins: 'Vitaminer: ',
        micronutrients: 'Mikronæringsstoff: ',
        pigments: 'Pigment: ',
        noBatches: 'Ingen partier for ordrelinje',
        ingredients: 'Sammensetning av fôrmidler',
        asc: {
          title: 'Fôr produsert i henhold til ASC-standarden, under massebalansemodellen',
          info: '(www.asc-aqua.org). ASC ID-nummer: {siteNumber}',
        },
      },
    },
    editOrder: {
      title: 'Endre ordre #{orderNumber}',
      deleteOrderBtn: 'Slett ordre',
      saveOrderBtn: 'Lagre ordre',
      orderLinesList: {
        removeOrderLine: 'Slett ordrelinje',
        addOrderLine: 'Legg til ordrelinje',
        orderDetailsLabel: 'Ordre detaljer',
        availableProducts: 'Vis tilgjengelige produkter',
        preferredProducts: 'Vis anbefalte produkter',
        itemNameLabel: 'Produkt',
        itemNumberLabel: 'Nummer',
        orderQuantityLabel: 'Kvantum',
        methodOfDeliveryLabel: 'Leveringsmetode',
        orderCommentLabel: 'Ordrekommentar',
        requestedDeliveryDateLabel: 'Foretrukket skipningsdato',
        packagingLabel: 'Forpakning',
      },
      editRecommendationOrder: {
        title: 'Endre ordre',
        save: 'Lagre ordre',
        add: 'Legg til produkt',
      },
    },
    listStarvation: {
      title: 'Planlagt sulting',
      starvingPeriodList: {
        noResults: 'Ingen funn',
        globalSiteIdLabel: 'Lokalitet',
        selectFishGroups: 'Velg Fiskegrupper',
        fishGroupNameLabel: 'Fiskegruppe / Merd',
        startDateLabel: 'Start dato',
        endDateLabel: 'Slutt dato',
        comment: 'Kommentar',
      },
      commentReason: {
        liceTreatment: 'Lusebehandling',
        harvest: 'Innhøsting',
        farmMaintenance: 'Gårdsvedlikehold',
        fishMovement: 'Fiskebevegelse',
        otherReason: 'Annen grunn',
        invalid: 'Ugyldig',
      },
    },
    orderFeedEdit: {
      invalid: 'Velg årsak',
      delousing: 'Avlusing',
      disease: 'Sykdom',
      increasedAppetite: 'Økt appetitt',
      reducedAppetite: 'Redusert appetitt',
      delayedDelivery: 'Forsinket leveranse',
      silosAreFull: 'Silo er full',
      silosAreEmpty: 'Silos er tom',
      scheduleChange: 'Ruteendring',
      harvest: 'Slakting',
      changeOfTheSupplier: 'Bytte fôrleverandør',
      fleetChange: 'Flåten skal byttes',
      noneOfTheAbove: 'Annet',
    },
    timeline: {
      title: 'Tidslinje',
      graph: {
        date: 'Dato',
        datetime: 'I dag',
        quantity: 'Mengde',
        inventory: 'Beholdning',
        dailyConsumption: 'Daglig forbruk',
        siloCapacity: 'Silo kapasitet',
        orderQuantity: 'Ordrevolum',
        recommendOrderQuantity: 'Foreslått bestilling',
        factoryVessel: 'Fabrikk - Fartøy',
        plannedStarvation: 'Planlagt sult',
        requestedDeliveryDate: 'Forespurt leveringsdato',
        unplannedStarvation: 'Uplanlagt sult',
      },
      starvation: {
        list: {
          globalSiteIdLabel: 'Lokalitet',
          selectFishGroups: 'Velg fiskegrupper',
          fishGroupNameLabel: 'Fiskegruppe / Merd',
          startDateLabel: 'Start dato',
          endDateLabel: 'Slutt dato',
        },
      },
      capacityBufferPercentage: 'Statisk kapasitetsbuffer',
      refillSiloToLabel: 'Fyll silo til',
      setInventoryBufferLabel: 'Bruk "Fyll silo til"',
      dynamicConsumptionBuffer: 'Dynamisk forbruksbuffer',
      siloTitle: 'Silo fyll buffer',
      infoCapacityBufferPercentage:
        "Adds the given percentage of the site's silo capacity to the buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.",
      infoDynamicConsumptionBuffer:
        'Adds the given number of days of average expected feed consumption to the silo buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.',
      infoRefillSiloToLabel:
        "Recommendations will aim to refill the silos to the given percentage of the site's silo capacity on every delivery.",
    },
  },
  profilesStrategies: {
    generalTitle: 'Generell',
    ownerTitle: 'Eier',
    linesTitle: 'Linjer',
    feedStrategy: 'Fôrstrategi',
    label: {
      name: 'Navn',
      feedStrategyActive: 'Fôrstrategien er aktiv',
      feedStrategyTemporary: 'Fôrstrategi er midlertidig',
      startWeightLabel: 'Start vekt',
      product: 'Produkt',
      period: 'Periode',
      average: 'Gjennomsnitt',
      profileType: 'Profiltype',
      periodisation: 'Periodisering',
      profileSubType: 'Profil SubType',
      profile: 'Profil',
    },
    menuItem: {
      market: 'Marked',
      company: 'Selskap',
      site: 'Lokalitet',
      connectedFishGroups: 'Antall tilkoblede fiskegrupper',
    },
    navigation: {
      listFeedStrategies: 'Forstrategier',
      listProfiles: 'Profiler',
      editMarketProfiles: 'Markedsprofiler',
      editSiteProfiles: 'Lokalitetsprofiler',
    },
    listFeedStrategies: {
      title: 'Foôrstrategier',
      createButton: 'Opprett strategi',
      isUserAuthorized: 'Cargill administrator kan gi deg tilgang til denne siden',
      list: {
        noResults: 'Ingen fôrstrategi funnet',
        nameLabel: 'Navn',
        numberOfConnectedFishGroupsLabel: 'Antall Fiskegrupper',
        activeLabel: 'Aktiv',
        isTemporaryLabel: 'Midlertidige',
      },
      filters: {
        state: {
          title: 'Status',
          active: 'Aktiv',
          isTemporary: 'Midlertidig',
        },
      },
    },
    listProfiles: {
      title: 'Profiler',
      createButton: 'Opprett Profil',
      list: {
        noResults: 'Ingen profiler funnet',
        nameLabel: 'Navn',
        activeLabel: 'Aktiv',
        isTemporaryLabel: 'Midlertidige',
        numberOfConnectedFishGroupsLabel: 'Antall Fiskegrupper',
      },
      filters: {
        state: {
          title: 'Status',
          active: 'Aktiv',
          isTemporary: 'Midlertidige',
        },
      },
    },
    createFeedStrategies: {
      title: 'Opprett Fôrstrategi',
      duplicateProfiles: 'Startvektverdien dupliseres',
      startWeightValue: 'Første startvektverdi skal starte på null',
    },
    editFeedStrategies: {
      title: '{name}',
      duplicateProfiles: 'Startvektverdien dupliseres',
      startWeightValue: 'Første startvektverdi skal starte på null',
      productInactive: 'Product inactive, please select from the list',
    },
    createProfiles: {
      title: 'Opprett Profil',
      profiles: {
        egi: 'EGI',
        efi: 'EFI',
        mort: 'Dødelighet',
      },
    },
    editProfiles: {
      title: '{name}',
      profileToggle: {
        active: 'Profilen er aktiv',
        temporary: 'Profilen er midlertidig',
        circular: 'Profilen er sirkulær',
        input: 'Profilen er fra Input',
      },
    },
    editMarketProfiles: {
      title: 'Administrer markedsprofiler',
      submitButton: 'Lagre profil',
      list: {
        noResults: 'Ingen profiler funnet',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Fôrstrategi',
        mortalityLabel: 'Dødelighet',
        smoltTypeNameLabel: 'Smolttype',
        speciesNameLabel: 'Art',
      },
    },
    editSiteProfiles: {
      title: 'Vedlikehold Lokalitetsprofiler',
      siteLabel: 'Lokalitet',
      selectSite: 'Velg lokalitet',
      harvestTargetLabel: 'Ønsket slaktevekt',
      weight: 'Vekt',
      date: 'Dato',
      defaultProfiles: 'Standard profiler',
      list: {
        noResults: 'Ingen profiler funnet',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Fôrstrategi',
        mortalityLabel: 'Dødelighet',
        smoltTypeNameLabel: 'Smolt Type',
        speciesNameLabel: 'Art',
      },
    },
  },
  planningPrognosis: {
    navigation: {
      listSites: 'Lokaliteter',
      listNotifications: 'Varsler',
    },
    createVirtualFishGroup: {
      stockingDate: 'Utsettsdato',
      name: 'Navn',
      numberOfFish: 'Antall fisk',
      stockingWeight: 'Utsettsvekt, g',
      species: 'Art',
      smoltType: 'Smolt type',
      strain: 'Stamme',
    },
    calculator: {
      egiProfile: 'EGI',
      efiProfile: 'EFI',
      mortProfile: 'Dødelighet',
      tempProfile: 'Temperatur',
      fishGroup: 'Fiskegrupper',
      calculate: 'Kalkuler',
      startDate: 'Start dato',
      latitude: 'Lengdegrad',
      quantity: 'Antall fisk',
      species: 'Art',
      meanWeight: 'Snittvekt, g',
      harvestTarget: 'Ønsket slaktevekt: 5,5kg',
    },
    listSites: {
      title: 'Lokaliteter',
      list: {
        nameLabel: 'Lokalitet',
        activeFishGroupsLabel: 'Aktive fiskegrupper',
        biomassLabel: 'Biomasse, kg',
        noResults: 'Ingen lokaliteter funnet',
        noFishLabel: 'Antall fisk',
        avgWeightLabel: 'Snittvekt, g',
      },
      dialogMultiProfiles: {
        dialogButton: 'Rediger lokalitet',
        title: 'Rediger lokalitet',
      },
      dialogMultiTempProfiles: {
        dialogButton: 'Rediger midlertidig profil',
        title: 'Rediger midlertidig profil',
      },
    },
    viewSite: {
      title: '{siteName}',
      activitiesTitle: 'Siste innsendte prognoser',
      fishGroupList: {
        editMultiple: 'Rediger flere fiskegrupper',
        noResults: 'Ingen fiskegruppe funnet',
        lastFishGroupIdFromXmlLabel: 'Nr.',
        fishGroupNameLabel: 'Fiskegruppenavn',
        unitNameLabel: 'Merd',
        smoltNameLabel: 'Smolttype',
        stockingDateLabel: 'Dato',
        stockingWeightLabel: 'Utsettsvekt, g',
        currentWeightLabel: 'Vekt, g',
        accEgiLabel: 'EGI',
        accEfiLabel: 'EFI',
        hasTemporaryLabel: 'Temperatur',
        mortality: 'Dødelighet',
        feedStrategy: 'Fôrstrategi',
        createVirtualFG: 'Opprett virtuell fiskegruppe',
      },
      forecastList: {
        noResults: 'Ingen innsendte prognoser',
        userIdLabel: 'Bruker',
        dateLabel: 'Dato',
        commentLabel: 'Kommentar',
      },
      dialogForecast: {
        dialogButton: 'Send prognose',
        title: 'Send prognose',
        commentLabel: 'Kommentar',
      },
      planningPrognosisTabs: {
        fishGroups: 'Fiskegrupper',
        virtual: 'Virtuell',
        harvest: 'Slaktet',
        changeProfiles: 'Endre profiler',
        calculator: 'Kalkulator',
      },
    },
    viewFishGroup: {
      title: '{unitName} - {fishGroupName}',
      snapshotsList: {
        title: 'Øyeblikksbilde',
        noResults: 'Ingen øyeblikksbilder funnet',
        nameLabel: 'Navn',
        realLabel: 'Faktisk',
        prognosisLabel: 'Prognose',
        planLabel: 'Planlagt',
        showLabel: 'Forestilling',
      },
      profileList: {
        title: 'Profiler',
        resetDefaultsBtn: 'Tilbakestill til lokalitetsprofiler',
        profileLabel: 'Profil',
        valueLabel: 'Verdi',
        levelLabel: 'Nivå',
        harvestTarget: 'Ønsket slaktevekt',
        egi: 'EGI',
        efi: 'EFI',
        mortality: 'Dødelighet',
        feedStrategy: 'Fôrstrategi',
        temperature: 'Temperatur',
        profileLevelCountry: 'Marked',
        profileLevelSite: 'Lokalitet',
        profileLevelFishGroup: 'Fiskegruppe',
        dialogDeleteVirtual: 'Slett virtual fiskegruppe',
        emptyLevel: 'Ikke definert',
      },
      profilesDialog: {
        title: 'Endre {type} profil',
        byWeightLabel: 'Ønsket slaktevekt',
        weightBtn: 'Vekt',
        dateBtn: 'Dato',
        weightLabel: 'Vekt',
        dateLabel: 'Dato',
        egiLabel: 'EGI',
        efiLabel: 'EFI',
        mortalityLabel: 'Dødelighet',
        feedStrategyLabel: 'Fôrstrategi',
      },
      feedStrategyList: {
        title: 'Se fôrstrategi',
        fromWeightLabel: 'Fra vekt',
        nameLabel: 'Produktnavn',
        editBtn: 'Rediger fôrstrategi',
      },
      temporaryPlanningList: {
        title: 'Midlertidig profil',
        noResults: 'Ingen midlertidig profil funnet',
        editTemporaryProfiles: 'Rediger midlertidige profiler og fôrstrategier',
        assignTemporary: 'Sett midlertidige profiler og fôrstrategier',
        profile: 'Profil',
        type: 'Type',
        id: 'Id',
      },
    },
    listNotifications: {
      title: 'Varsler',
      list: {
        noResults: 'Fant ingen varsler',
        startDateLabel: 'Startdato',
        endDateLabel: 'Sluttdato',
        unitNameLabel: 'Merd',
        fishGroupNameLabel: 'Fiskegruppe',
        siteNameLabel: 'Lokalitet',
        commentLabel: 'Kommentar',
      },
    },
    alert: {
      title: 'Beregning pågår',
      info: 'Planleggings- og prognosedataene dine blir beregnet, vennligst vent noen minutter',
    },
    tabs: {
      activeSite: 'Aktiv',
      harvested: 'Slaktet',
      other: 'Annen leverandør',
      active: 'Aktiv',
      historic: 'Historisk',
    },
    feedSummary: {
      title: 'Sammendrag av lokalitet',
      graphDate: 'Dato',
      graphValue: 'Verdi',
      actual: 'Faktisk',
      planned: 'Planlagt',
      delivered: 'Levert',
      forecast: 'Prognose',
    },
    siteDetails: {
      title: 'Fôrplan lokalitet',
      showTableBTN: 'Vis tabell',
    },
  },
  bluViuNutrition: {
    title: 'Simulate Feed Programs',
    navigation: {
      listScenarios: 'bluViu Nutrition R1',
      listCalibrations: 'Calibrations',
      listBluViuNutritionR2: 'bluViu Nutrition R2',
      viewScenarioResult: 'Result',
      viewScenarioResultGt2: 'Result',
    },
    listScenarios: {
      title: 'Scenarios',
      createButton: 'Create Scenario',
      copy: 'Copy',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      createDialog: {
        title: 'Create scenario',
        nameLabel: 'Name',
        isLandBasedFarmingLabel: 'Model name',
      },
      cloneDialog: {
        title: 'Clone scenario',
        emptyModel: 'Outdated scenarios cannot be copied',
        nameLabel: 'Name',
      },
      list: {
        noResults: 'No scenarios found',
        modelLabel: 'Model',
        nameLabel: 'Name',
        updatedDateLabel: 'Updated',
        stateLabel: 'State',
      },
      filters: {
        state: {
          title: 'State',
        },
      },
    },
    viewScenarioResult: {
      title: 'Result for {name}',
      exportCSVBtn: 'Export to CSV',
      noScenario: 'No Scenario selected',
      tabs: {
        siteSummaryLabel: 'Site Summary',
        unitSummaryLabel: 'Unit Summary',
        lcaSummaryLabel: 'LCA Summary',
      },
      filters: {
        title: 'Show Data',
        columns: {
          permutation: 'Permutation',
          feedIntakeTons: 'Feed Intake, T',
          productionWeeks: 'Production Weeks',
          stockingBiomassTons: 'Stocking Biomass, T',
          harvestBiomassTons: 'Harvest Biomass, T',
          harvestHogBiomassTons: 'Harvest Hog Biomass, T',
          harvestCount: 'Harvest Count',
          salesIncomeMillions: 'Sales Income, M',
          feedCostMillions: 'Feed Cost, M',
          fishCostMillions: 'Fish Cost, M',
          operationsCostMillions: 'Operations Cost, M',
          harvestCostMillions: 'Harvest Cost, M',
          totalCostMillions: 'Total Cost, M',
          netProfitMillions: 'Net Profit, M',
          netProfitMillionsPerYear: 'Net Profit, M/Year',
          harvestHogBiomassTonsPerYear: 'Harvest Hog Biomass, T/Year',
          bFcr: 'bFcr',
          eFcr: 'eFcr',
          gwpTons: 'gwp, T',
          lostNTons: 'Lost N, T',
          feedProgram: 'Feed Program',
          productionUnit: 'Production Unit',
          breakPeriodWeeks: 'Break Period Weeks',
          harvestWeightGPerFish: 'Harvest Weight, g/Fish',
          harvestHogWeightGPerFish: 'Harvest Hog Weight, g/Fish',
          feedIntakeGPerFish: 'Feed Intake, g/Fish',
          filletAxMgPerKg: 'Fillet Ax, mg/kg',
          growthTons: 'Growth, T',
          fishGroupId: 'Fish Group Id',
        },
        lcaColumns: {
          fishGroupId: 'Fish Group Id',
          perm: 'Perm',
          prodDays: 'Prod Days',
          unitName: 'Unit Name',
          L132: 'Global warming - incl LUC, kg CO₂ eq',
          L131: 'Global warming - excl LUC, kg CO₂ eq',
          L133: 'Stratospheric ozone depletion, kg CFC11 eq',
          L134: 'Ionizing radiation, kBq Co-60 eq',
          L135: 'Ozone formation, Human health, kg NOx eq',
          L136: 'Fine particulate matter formation, kg PM2.5 eq',
          L137: 'Ozone formation, Terrestrial ecosystems, kg NOx eq',
          L138: 'Terrestrial acidification, kg SO2 eq',
          L139: 'Freshwater eutrophication, kg P eq',
          L140: 'Marine eutrophication, kg N eq',
          L141: 'Terrestrial ecotoxicity, kg 1,4-DCB',
          L142: 'Freshwater ecotoxicity, kg 1,4-DCB',
          L143: 'Marine ecotoxicity, kg 1,4-DCB',
          L144: 'Human carcinogenic toxicity, kg 1,4-DCB',
          L145: 'Human non-carcinogenic toxicity, kg 1,4-DCB',
          L146: 'Land use, m2a crop eq',
          L147: 'Mineral resource scarcity, kg Cu eq',
          L148: 'Fossil resource scarcity, kg oil eq',
          L149: 'Water consumption, m3',
          L150: 'Land Use Change (LUC), kg CO₂ eq',
          feedProgram: 'Feed Program',
          feedName: 'Feed Name',
          endStage: 'End Stage',
        },
      },
      label: {
        endStageSeaProductions: 'End Stage Sea Productions',
        endStageHog: 'End Stage Hog',
      },
    },
    viewScenarioResultGt2: {
      title: 'Summary Type',
      exportCSVBtn: 'Export results',
      referenceFeedProgram: 'Select Reference Feed Program',
      getResult: 'Get Results',
      noScenario: 'No Scenario selected',
      compareFeeds: 'Compare now',
      weeksRangeRequired: 'Please enter a week number between {minWeek} and {maxWeek}',
      weightsRangeRequired: 'Please enter weight in the range between {minWeight} g and {maxWeight} g ',
      adjustWeekLabel: 'Adjust weeks to range',
      adjustWeightLabel: 'Adjust weight to range',
      topPerformers: 'Top performers',
      lowestCo2Feed: 'has {percentage}% lower CO₂ emission per kg growth than the second best feed program',
      bestBiologyFeedWeek: 'resulted in {percentage}% higher weight gain after {week} weeks than the second best feed program',
      bestBiologyFeedWeight: 'reached the target weight {daysToReach} days quicker than the second best feed program',
      mostEconomicalFeed: ' resulted in {percentage}% lower average feed price than the second best feed program',
      selectedFeeds: 'You have {quantity} feed programs selected',
      productionRangeMessage: 'Scenario is outside of the intended scenario production range',
      clear: 'Clear',
      fixedNumber: 'less than 0.1',
      icons: {
        lowestCo2Title: 'Lowest CO₂',
        bestBioTitle: 'Fastest growth',
        mostEconomicalTitle: 'Lowest feed price',
        bestBFcrTitle: 'Best bFCR',
        lowestCostOfGrowthTitle: 'Lowest cost of growth',
      },
      compareDialog: {
        compareDialogTitle: 'Compare feed programs',
        table: 'Table',
        graph: 'Graph',
      },
      kpis: {
        selectAll: 'Select all',
        labels: {
          finalWeightGrams: 'Sluttvekt',
          weightGainGrams: 'Tilvekst',
          hogGainGrams: 'HOG-tilvekst',
          daysToReach: 'Dager til slakt',
          feedIntakeGrams: 'Fôrinntak',
          bFcr: 'bFCR',
          eFcr: 'eFCR',
          carcassYieldPercent: 'Slakteutbytte',
          filletFatPercent: 'Filetfett',
          averageFeedCostPerKgFeed: 'Gjennomsnittlig fôrkost',
          feedCostOfGrowth: 'Fôrkost per kg tilvekst',
          feedCostOfHogGain: 'Fôrkost per kg HOG-tilvekst',
          feedCostTotal: 'Total fôrkost',
          operationsCostTotal: 'Total driftskost',
          smoltCostTotal: 'Total smoltkost',
          harvestCostTotal: 'Total slaktekost',
          treatmentCostTotal: 'Total lakseluskost',
          totalCost: 'Total kost',
          potentialSalesValue: 'Potensiell salgsverdi',
          potentialProfit: 'Forventet fortjeneste',
          globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg fôr',
          globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg tilvekst',
        },
        tooltips: {
          finalWeightGrams: 'Gjennomsnittlig fiskevekt ved slutten av scenariet. Formel: Startvekt + tilvekst',
          weightGainGrams: 'Gjennomsnittlig vektøkning per fisk. Formel: Sluttvekt - startvekt',
          hogGainGrams:
            'Gjennomsnittlig HOG-tilvekst per fisk, beregnet som salgbare head-on-gutted-andelen av fiskens tilvekst. Formel: HOG-tilvekst = tilvekst × slakteutbytte',
          daysToReach: 'Antall dager fra scenariostart til sluttvekt er oppnådd',
          feedIntakeGrams: 'Gjennomsnittlig fôrforbruk per fisk gjennom scenarioperioden',
          bFcr: 'Biologisk fôrfaktor. Mengde fôr som kreves for å produsere 1 kg tilvekst. Formel: Fôrinntak ÷ tilvekst',
          eFcr: 'Økonomisk fôrfaktor. Fôrforbruk per kg produsert biomasse inkludert effekten av tap i produksjonen',
          carcassYieldPercent: 'Forventet slakteutbytte ved slakt. Formel: HOG-vekt ÷ levende vekt × 100',
          filletFatPercent: 'Forventet fettinnhold i fileten ved slakt',
          averageFeedCostPerKgFeed:
            'Vektet gjennomsnittlig fôrkost for fôrprogrammet basert på forventet fôrforbruk av hvert fôr i programmet. Formel: Total fôrkost ÷ totalt fôrforbruk',
          feedCostOfGrowth: 'Vektet gjennomsnittlig fôrkost for å produsere 1 kg tilvekst. Formel: Total fôrkost ÷ total tilvekst',
          feedCostOfHogGain:
            'Vektet gjennomsnittlig fôrkost for å produsere 1 kg HOG-tilvekst. Formel: Total fôrkost ÷ total HOG-tilvekst',
          feedCostTotal: 'Total kost for alt fôr brukt i scenariet',
          operationsCostTotal: 'Totale driftskostnader basert på produksjonstid og driftskostnad per uke',
          smoltCostTotal: 'Totale smoltkost basert på antall utsatt smolt og smoltkostnad per smolt',
          harvestCostTotal: 'Totale slaktekost basert på sluttbiomasse og slaktekostnad per kg',
          treatmentCostTotal: 'Totale lakseluskostnader basert på antall behandlinger og kostnad per behandling',
          totalCost:
            'Total produksjonskost inkludert fôrkost og øvrige produksjonskoster (behandlinger, faste kostnader, variable kostnader osv.)',
          potentialSalesValue:
            'Estimert salgsverdi av produsert HOG-biomasse. Formel: Total HOG-biomasse × relevant salgspris per kg HOG',
          potentialProfit:
            'Estimert fortjeneste etter fratrekk av produksjonskoster. Formel: Potensiell salgsverdi - total produksjonskost',
          globalWarmingPotentialCo2KgPerKgFeed:
            'Vektet gjennomsnittlig klimaavtrykk per kg fôr basert på iLUC-verdien og forventet fôrforbruk for hvert fôr i programmet',
          globalWarmingPotentialCo2KgPerKgGrowth: 'Klimafotavtrykk per kg tilvekst. Formel: GWP CO₂/kg fôr × bFCR',
        },
      },
      tooltip: {
        weightGainGrams: 'Predicted final weight of the fish minus stocking weight',
        feedIntakeGrams: 'Predicted total feed consumption',
        filletFatPercent: 'Predicted % of fat in the fillet',
        feedCostOfGrowth:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        carcassYieldPercent: 'Predicted % of fish that becomes HOG (Head-on-gutted). Fish weight – guts, visceral fat',
        finalWeightGrams: 'Model predicts the final weight of the fish',
        bFcr: 'Predicted total feed intake / weight gain',
        averageFeedCost:
          'For each feed program: The price of each feed multiplied by the amount of feed supplied, added together, and divided by the total amount of feed supplied',
        feedCostOfHogGrowth:
          'Total predicted feed cost / (weight gain x carcass yield).  Example:75kr total feed cost / 4000g weight gain x 88% carcass yield = 21.30 NOK',
        globalWarmingPotentialCo2KgPerKgGrowth: 'Total global warming potential (I_LUC) x predicted feed consumed / kg weight gain',
        hogGainGrams:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        tooltipContent: 'Feed program',
        feedsInProgram: 'Feeds in program: ',
      },
      compareTable: {
        finalWeightGrams: 'Final Weight',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain',
        feedIntakeGrams: 'Feed Intake',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield (%)',
        filletFatPercent: 'Fillet Fat (%)',
        hogGainGrams: 'HOG Gain (g)',
        globalWarming: 'GWP CO₂/kg growth',
        averageFeedCost: 'Average Feed Cost',
        feedCostOfGrowth: 'Feed Cost Of Growth',
        feedCostOfHogGrowth: 'Feed Cost Of HOG Growth',
        reference: 'Reference',
      },
      filters: {
        types: {
          week: 'Week',
          weight: 'Weight',
        },
        visibleKpis: 'Visible KPIs',
        week: 'Week',
        weekLabel: 'Enter {minWeek} - {maxWeek} weeks',
        weight: 'Target Weight',
        weightLabel: 'Enter {minWeight} - {maxWeight} g',
      },
      columns: {
        feedPlan: 'Feed Program',
        feedPlanMaxWeeks: 'Feed Plan Max Weeks',
        feedPlanMaxWeight: 'Feed Plan Max Weight',
        finalWeightGrams: 'Final Weight(g)',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain(g)',
        feedIntakeGrams: 'Feed Intake(g)',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield(%)',
        filletFatPercent: 'Fillet Fat(%)',
        hogGainGrams: 'HOG Gain(g)',
        globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg growth',
        globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg feed',
        averageFeedCost: 'Avg. Feed Cost',
        feedCostOfGrowth: 'Avg. Cost Of Growth',
        feedCostOfHogGrowth: 'Cost Of HOG Gain',
      },
      tabs: {
        compare: 'Compare',
        result: 'Results',
        graph: 'Graph',
      },
      graph: {
        yWeight: 'Weight',
        xWeek: 'Week',
        productionWeek: 'Production Week',
      },
    },
    setUp: {
      title: 'Setup a site',
      viewResultsBTN: 'View Result',
      submit: 'Submit Scenario',
      save: 'Save',
      label: {
        name: {
          title: 'Scenario name',
          modelName: 'Scenario model',
          placeholder: 'Add scenario name',
        },
        site: 'Select Site',
        calibration: 'Calibration',
        description: {
          title: 'Scenario description',
          placeholder: 'Add scenario description',
        },
      },
      warningText: {
        calibration: 'Site is not calibrated.',
        modelType: 'Site has incorrect model.',
        range: 'Start weight has to be between 50 and 3000',
      },
      settingsRun: {
        title: 'Scenario settings and run',
        startDate: 'Start Date',
        endDate: 'End Date',
        fishWeight: 'Start Weight',
        startDateError: 'Start Date is not before End Date',
        endDateError: 'End Date is not after Start Date',
      },
    },
    availableFeeds: {
      title: 'Available feeds',
      save: 'Save',
      label: {
        feedProgram: 'Feed program',
        fishSize: 'Fish size',
        feed: 'Feed',
        feedSource: 'Feed source',
        feedAx: 'Feed ax, mg/kg',
        feedMaizeGluten: 'Feed maize gluten(%)',
        relativeMortalityImpact: 'Relative mortality impact',
        relativeGrowthImpact: 'Relative growth impact',
        salmonPricePremium: 'Price premium /kg gutted',
        formulationCost: 'Formulation cost /ton',
        customerPrice: 'Customer price',
      },
    },
    availableFeedsEEGt2P: {
      title: 'Scenario feed programs',
      select: {
        currency: 'Currency',
        NOK: 'NOK/100kg',
        USD: 'USD/ton',
      },
    },
    settingsRun: {
      title: 'Scenario settings',
      addCustomBtn: 'Add Custom Unit',
      label: {
        selectProductionUnit: 'Select Production Unit',
        currency: 'Currency',
        unit: 'Unit',
        fishWeight: 'Fish weight, g',
        fishCount: 'Fish count',
        statDate: 'Start date',
        fishCost: 'Fish cost (per kg stocked)',
        dailyCost: 'Daily cost (per day)',
        harvestCost: 'Harvest cost (per kg HOG)',
        simulationFor: 'Simulation for',
        targetWeight: 'Target weight (g)',
        productionWeeks: 'Production Weeks',
        breakPeriod: 'Break period before restocking (weeks)',
        salmonPrice: 'Salmon price {currency}',
        fishpoolPrice: 'Fishpool price {currency}',
        enterManually: 'Enter manually',
        selectionCriteria: 'Selection criteria',
        feedConversionBiological: 'Feed Conversion Biological',
        feedCostPerSite: 'Feed Cost/Site',
        harvestHogPerSitePerYear: 'Harvest Hog/Site/Year',
        netProfitPerSite: 'Net Profit/Site',
        netProfitPerSitePerYear: 'Net Profit/Site Per Year',
        productionTime: 'Production Time',
        salesIncomePerSite: 'Sales Income/Site',
        totalCostPerSite: 'Total Cost/Site',
        setRegulatoryFramework: 'Set regulatory framework',
        noLimits: 'No limits',
        maximumAllowedBiomass: 'Maximum allowed biomass',
        harvestMethod: 'Harvest method',
        batchHarvest: 'Batch Harvest',
        allowedBiomass: 'Allowed biomass limit (tons)',
      },
    },
    calibrations: {
      listCalibrations: {
        stateTooltip: {
          modified:
            'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
        },
        list: {
          name: 'Name',
          model: 'Model',
          calibratedAt: 'Calibrated at',
          growth: 'Growth',
          feedIntake: 'Feed intake',
          state: 'State',
        },
      },
      createCalibration: {
        create: 'Create calibration',
      },
      cloneCalibration: {},
      editCalibration: {
        calibrationInProgress: {
          title: 'Calibration in progress',
          text: 'You are free to leave this page while the calibration is running. This may take a few minutes depending on the complexity of your site data.',
        },
        calibrationStatistics: {
          status: {
            title: 'Status',
            modifiedTooltip:
              'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
          },
          weightGain: {
            title: 'Weight gain',
          },
          feedIntake: {
            title: 'Feed intake',
          },
        },
        calibrationActions: {
          exportScript: 'Export Script',
          exportCSV: 'Export CSV',
          clone: 'Clone',
        },
        calibrationInformation: {
          title: 'Calibration',
          form: {
            name: 'Calibration name',
            model: 'Calibration model',
            description: 'Calibration description',
          },
        },
        temperatureLocation: {
          temperatureProfile: {
            title: 'View Temperature Profile',
            dialogButton: 'View Temperature Profile',
            buttonGroup: {
              graph: 'Graph',
              list: 'List',
            },
            header: 'Average Temperature',
            chart: {
              week: 'Week',
              degrees: 'Degrees',
            },
            table: {
              week: 'Week',
              temperature: 'Temperature',
            },
            information: 'To edit your temperature profile, go to site settings.',
          },
          location: {
            title: 'Longitude and latitude',
            dialogButton: 'View Location',
            latitude: 'Latitude',
            longitude: 'Longitude',
            information: 'To edit your location, go to site settings.',
          },
          information: 'No temperature profile available, create one in site settings.',
        },
        inputs: {
          title: 'Inputs',
          single: {
            form: {
              stockingDate: 'Stocking date',
              stockingFishWeight: 'Stocking fish weight',
              harvestDate: 'Harvest date',
              harvestFishWeight: 'Harvest fish weight',
              harvestCyclebFcr: 'Harvest Cycle bFCR',
            },
          },
          multi: {
            selectYear: 'Select year',
            information: 'Select year that you want to use as inputs for calibration.',
            cages: {
              information: 'Select cages that you want to use as inputs for calibration.',
              list: {
                fishGroup: 'Fish group',
                cageTooltip: 'Cage: {unitName}',
                stockingDate: 'Stocking date',
                startWeight: 'Start weight',
                bFCR: 'bFCR',
                harvestDate: 'Harvest date',
                avgHarvestMW: 'Avg. Harvest MW',
                egi: 'EGI',
              },
            },
          },
        },
        feedProgram: {
          title: 'Feed program',
          columns: {
            feed: 'Feed',
            quantity: 'Fish start size (g)',
          },
        },
        runCalibration: {
          information: 'Running the calibration may take a while depending on the complexity of your site data.',
          button: 'Run calibration',
        },
      },
    },
    applyFeed: {
      title: 'Bruk fôrprogrammer',
      stepIndicator: 'Steg {step} av {total} - {stepLabel}',
      buttonLabel: 'Bruk fôrprogrammer',
      confirmAndApply: 'Bekreft og bruk',
      missingMapping: 'Noen produkter er ennå ikke kartlagt',
      applyAs: {
        label: 'Bruk som:',
        plan: {
          title: 'Plan',
          description: 'Den faktiske planen som lokaliteten vil følge.',
        },
        forecast: {
          title: 'Projeksjon',
          description: 'Et "Hva om"-scenario å bruke gjennom produksjonssyklusen.',
        },
        planAndForecast: {
          title: 'Plan og Projeksjon',
          description: 'Bruker scenariet som både plan og projeksjon.',
        },
      },
      reviewList: {
        title: 'Gjennomgå fôrprogrammer før du bruker dem på lokaliteten:',
        fishGroup: 'Fiskegruppe',
        newFeedProgram: 'Nytt fôrprogram',
      },
      excludedFishGroups: {
        title: 'Ekskluderte fiskegrupper',
      },
      mapping: {
        infoBox:
          'Produkter i bluViu Nutrition er ikke de samme som i SAP. Kartlegg produktene i fôrprogrammene slik at bluViu Nutrition og OFD kan kobles sammen.',
        weight: 'Vekt',
        feedsInBluViuNutrition: 'Fôr i bluViu Nutrition',
        feedsInSAP: 'Fôr i SAP',
        product: 'Produkt *',
        mappedLabel: 'kartlagt',
      },
    },
  },
  bluViuNutritionR2: {
    scenarioValidation: {
      invalidFishGroupData: 'One or more fish groups contain invalid data.',
      reviewFishGroupData: 'Please review the imported fish-group data.',
      reviewScenarioEndDate: 'Please review the Scenario end date in the Production Inputs section below.',
    },
    results: {
      graph: {
        allAvgForSite: 'All (Avg. for site)',
        allPrograms: 'All Programs',
        potentialSalesValue: 'Potential Sales Value',
        potentialSalesValueDisabled: 'Select one feed program to view potential sales value.',
        showFeedProgram: 'Show feed program',
        showResultsFor: 'Show results for',
        valueBySizeClass: 'Total value by size class',
        valueBySizeClassDisabled: 'Select one feed program to view value by size class.',
        weeks: 'Weeks',
        weight: 'Weight (g)',
      },
    },
  },
  fishCheck: {
    navigation: {
      listWelfareScoring: 'Velferdsscore',
      dialog: {
        deleteTitle: 'Slett eksempel',
        title: 'Start',
        templateAndSiteLabel: 'Velg lokalitet og mal',
        templateLabel: 'Mal',
        nameLabel: 'Skriv inn navn',
        siteLabel: 'Velg lokalitet',
      },
    },
    header: {
      siteNameLabel: 'Lokalitet',
      dateCreatedLabel: 'Dato opprettet',
      dateLastUpdatedLabel: 'Dato siste oppdatering',
      activeLabel: 'Aktiv',
      commentLabel: 'Komment',
      addNewFishLabel: 'Legg til fisk',
    },
    listWelfareScoring: {
      title: 'Velferdsscore rapport',
      list: {
        noResults: 'Ingen resultat',
        nameLabel: 'Navn',
        siteNameLabel: 'Lokalitet',
        dateCreatedLabel: 'Opprettet',
        activeLabel: 'Aktiv',
      },
    },
    editWelfareScoring: {
      title: 'Rediger {name}',
      editTitle: 'Rediger prøve',
      updateSample: 'Oppdater eksempel',
      alert: 'Ett eller flere felt må ha en verdi',
      fishGroupIdLabel: 'Velg merd:',
      dateCreatedLabel: 'Velg dato:',
      fishWelfareData: {
        cageLabel: 'Merd',
        fishGroupLabel: 'FIskegruppe',
        adultFemaleLice: 'Kjønnsmodne hunnlus',
        kFactor: 'K-Faktor',
        skinBleeding: 'Hudblødning',
        wounds: 'Kroppssår',
        length: 'Lengde',
        weight: 'Vekt',
        stationaryLice: 'Fastsittende',
        mobileLice: 'Bevegelige',
        scottishLice: 'Skottelus',
        backboneDeformity: 'Ryggradsdeformiteter',
        thinness: 'Avmagring',
        maturation: 'Kjønnsmodning',
        scaleLoss: 'Skjelltap',
        snoutWounds: 'Snutesår',
        jawDeformity: 'Kjevedeformiteter',
        paleEye: 'Øyeblakking',
        eyeDamage: 'Øyeskade',
        gillCover: 'Gjellelokk',
        gillStatus: 'Gjellestatus',
        finStatus: 'Finnestatus',
        firstImpression: 'Førsteinntrykk',
        comment: 'Kommentar',
      },
    },
  },
  feedManagement: {
    navigation: {
      listPlants: 'Planter',
      listNutrients: 'Ernæring',
      listBestMixFeeds: 'BestMix Feeds',
      listManualFeeds: 'Manual Feeds',
      listCustomers: 'Kunder',
    },
    listPlants: {
      title: 'Planter',
      button: 'Lag planter',
      list: {
        noResults: 'Du har ingen planter',
        codeLabel: 'Kode',
        nameLabel: 'Navn',
        marketsLabel: 'Markeder',
      },
      dialog: {
        title: 'Opprett nytt anlegg',
        codeLabel: 'Kode',
        marketsLabel: 'Marked',
        nameLabel: 'Navn',
      },
      tooltip: {
        product: 'Products does not have base nutrient values to support nutrient calculation',
        incorrectValues: 'BestMix nutrients updated by BluViu',
      },
    },
    listNutrients: {
      title: 'Velg Nutrients',
      digestibleFatGPerKgLabel: 'Fordøyelig fat',
      feedGwpKgCo2EqPerKgLabel: 'Fôr Gwp',
      idealProteinNitrogenLabel: 'Ideell proteinnitrogen',
      nonIdealProteinNitrogenLabel: 'Ikke-ideelt proteinnitrogen',
    },
    editPlant: {
      title: '{code} {name}',
      list: {
        title: 'Tilknyttede markeder',
        noResults: 'Ingen resultater',
        nameLabel: 'Marked',
        actionLabel: 'Fjerne',
      },
      selectMarketLabel: 'Velg Marked',
    },
    listBestMixFeeds: {
      title: 'Produkter',
      deactivateFeeds: 'Deactivate Feeds',
      activateFeeds: 'Activate Feeds',
      selectAllFeeds: 'Select All Feeds',
      linkToCustomer: 'Link to Customer',
      list: {
        noResults: 'Ingen resultater',
        nameLabel: 'Navn',
        numberLabel: 'Kode / Antall',
        updatedDateLabel: 'Oppdatert dato',
        activeLabel: 'Aktiv',
        inactiveLabel: 'Inaktiv',
      },
      filter: {
        plantLabel: 'Anlegg',
        statusLabel: 'BestMix status',
        options: {
          active: 'Aktiv',
          temporary: 'Arkiv',
          hasMandatoryNutrients: 'Ugyldig',
        },
      },
      dialog: {
        deactivate: 'Deactivate',
        activate: 'Activate',
        activateTitle: 'Activate Feeds',
        deactivateTitle: 'Deactivate Feeds',
        activateDialog: 'Are you sure you want to active the selected feeds?',
        deactivateDialog: 'Are you sure you want to deactive the selected feeds?',
        linkToSelectedCustomers: 'Link selected products?',
        customerSelect: 'Customers',
      },
      tooltip: {
        product: 'Product does not have base nutrient values to support nutrient calculation',
        incorrectValues: 'BestMix nutrients updated by BluViu',
      },
    },
    editBestMixFeed: {
      title: '{code} {name}',
      bestMixFeedDetails: {
        title: 'Produkt detaljer',
        descriptionLabel: 'Beskrivelse',
        plantCodeLabel: 'Plantekode',
        codeLabel: 'Kode',
        bestMixFeedNumberLabel: 'Antall',
        formulationCostLabel: 'Formuleringskostnad',
        bestMixFeedVersionLabel: 'Versjon',
      },
      assignedCompaniesList: {
        title: 'Tilknyttede kunder',
        noResults: 'Ingen resultater',
        nameLabel: 'Navn',
        priceLabel: 'Kunden Pris',
      },
      assignedCompaniesDialog: {
        openBtn: 'Koble kunde',
        title: 'Koble kunde',
        customerLabel: 'Kunden',
        customerPricePerToneLabel: 'Kunden Pris/Ton',
      },
      customFieldsList: {
        title: 'Egendefinerte felt',
        noResults: 'Ingen resultater',
        nameLabel: 'Navn',
        valueLabel: 'Verdi',
      },
      customFieldsDialog: {
        openBtn: '{action} til tilpasset felt',
        title: '{action} til tilpasset felt',
        customFieldsLabel: 'Egendefinerte felt',
        customFieldValueLabel: 'Verdi',
      },
      nutrientsMaterialsList: {
        nutrientsTitle: 'Ernæring',
        materialsTitle: 'Materialer',
        noResults: 'Ingen resultater',
        codeLabel: 'Code',
        nameLabel: 'Navn',
        valueLabel: 'Verdi',
      },
    },
    listCustomers: {
      title: 'Kunder',
      list: {
        noResults: 'Ingen Kunder',
        nameLabel: 'Kunden Navn',
      },
    },
    editCustomer: {
      title: '{name}',
      unlinkBtn: 'Koble fra',
      disconnectBtn: 'Disconnect feeds',
      selectAllFeeds: 'Select all feeds on current page',
      linkProductDialog: {
        openBtn: 'Link New BestMix Feed',
        title: 'Link BestMix Feed',
        productsLabel: 'BestMix Feeds',
        customerPricePerToneLabel: 'Kunden Pris/Ton',
      },
      disconnectDialog: {
        title: 'Disconnect feeds',
        disconnectLabel: 'Disconnect selected feeds?',
        disconnectBtn: 'Disconnect',
      },
      list: {
        title: 'Linked BestMix Feeds',
        noResults: 'No linked BestMix Feeds',
        descriptionLabel: 'Linked BestMix Feeds',
        customerPricePerTonLabel: 'Kunden pris per ton',
        hasMandatoryNutrientsLabel: 'Mangler næringsstoffer',
        hasIncorrectBestMixNutrientValuesLabel: 'Feil næringsverdier',
        updatedDateLabel: 'Updated Date',
      },
    },
    listManualFeeds: {
      title: 'Manual Feeds',
      deactivateFeeds: 'Deactivate Feeds',
      activateFeeds: 'Activate Feeds',
      selectAllFeeds: 'Select all feeds on current page',
      linkToCustomer: 'Link to Customer',
      createFeed: 'New Feed',
      dialog: {
        title: 'Create Manual Feed',
        nameLabel: 'Navn',
        pelletSizeLabel: 'Pellet størrelse',
        deactivate: 'Deactivate',
        activate: 'Activate',
        activateTitle: 'Activate Feeds',
        deactivateTitle: 'Deactivate Feeds',
        activateDialog: 'Are you sure you want to activate the selected feeds?',
        deactivateDialog: 'Are you sure you want to deactivate the selected feeds?',
        linkToSelectedCustomers: 'Link selected products?',
        customerSelect: 'Customers',
      },
      list: {
        noResults: 'Ingen fôr funnet',
        nameLabel: 'Navn',
        createdDateLabel: 'Opprettet dato',
        updatedDateLabel: 'Oppdatert dato',
        activeLabel: 'Aktiv',
        inactiveLabel: 'Inaktiv',
        feedFilterLabel: 'Filter',
        feedFilterOptions: {
          all: 'All',
          currentCompany: 'Valgt selskap',
          me: 'Min bruker',
          currentCompanyAndMe: 'Valgt selskap og min bruker',
        },
      },
    },
    editManualFeed: {
      title: 'Edit a Manual feed',
      nameLabel: 'Navn',
      activeLabel: 'Aktiv',
      inactiveLabel: 'Inaktiv',
      list: {
        essentialNLabel: 'Viktig N',
        effectiveEnergyLabel: 'Effektiv energi',
        nonEssentialNLabel: 'Ikke viktig N',
        crudeProteinLabel: 'Råprotein',
        feedGwpLabel: 'Fôr GWP',
        digestibleFatLabel: 'Fordøyelig fat',
        idealProteinNitrogenLabel: 'Ideal Protein Nitrogen',
        nonIdealProteinNitrogenLabel: 'Non-ideal Protein Nitrogen',
        scalingFactorFeedIntake: 'Scaling Factor Feed Intake',
        scalingFactorWeightGain: 'Scaling Factor Weight Gain',
      },
      customers: 'Kunder',
      users: 'Brukere',
      calculateNutrients: {
        title: 'Calculate nutrients',
        calculate: 'Calculate',
        list: {
          arginine: 'Digestible Arginine salmonids',
          histidine: 'Digestible Histidine salmonids',
          isoleucine: 'Digestible Isoleucine salmonids',
          leucine: 'Digestible Leucine salmonids',
          lysine: 'Digestible Lysine salmonids',
          methionine: 'Digestible Methionine salmonids',
          phenylalanineTyrosine: 'Digestible Phenylalanine + Tyrosine salmonids',
          threonine: 'Digestible Threonine salmonids',
          tryptophan: 'Digestible Tryptophan salmonids',
          valine: 'Digestible Valine salmonids',
          methionineCysteine: 'Digestible Methionine + Cysteine salmonids',
          protein: 'Digestible Protein salmonids',
        },
      },
    },
  },
  powerBi: {
    navigation: {
      listReports: 'Rapporter',
    },
    listReports: {
      title: 'Rapporter',
      list: {
        noResults: 'Ingen funn',
        nameLabel: 'Navn',
      },
    },
    viewReport: {
      utils: {
        downloadBtn: 'Last ned PDF',
        exportBtn: 'Eksportèr PDF',
        fullscreenBtn: 'Fullskjerm',
      },
      error: {
        message: 'Rapporten du prøver å få tilgang til kan ikke finnes for øyeblikket',
        title: 'Rapporter',
      },
    },
  },
  fileSharing: {
    title: 'Fildeling',
    currentFolder: 'Gjeldende mappe',
    subFolders: 'Undermapper',
    files: 'filer',
    selectFromList: 'Select file from the list',
    list: {
      name: 'Navn',
      dateCreated: 'Opprettet',
      folderName: 'Mappenavn',
      noSubFolders: 'Ingen undermapper funnet',
    },
  },
  seaCloudFileUpload: {
    cancelButton: 'Avbryt og kast filen',
    navigation: {
      viewFileSummary: 'Filopplasting',
    },
    viewFileSummary: {
      title: 'Send gårdsdata til SeaCloud',
    },
  },
  shrimpDataUpload: {
    navigation: {
      viewShrimpDataUpload: 'Filopplasting',
    },
    fileTypeError: 'Unsupported file type. Please upload an Excel (.xlsx or .xls) file.',
    uploadSuccess:
      'File successfully uploaded! Processing the file can take some time, you will get a detailed report via email once it is done.',
    uploadButton: 'Upload file',
    chooseProductionFile: 'Choose a PRODUCTION data file for upload',
    chooseSanitationFile: 'Choose a SANITARY data file for upload',
    chooseFile: 'Choose file',
  },
  productionSystems: {
    lockPondContainer: {
      partialLock: {
        bold: 'Some ponds have been looked by another user.',
        message: 'These ponds will not be included in your work session/registration.',
      },
      fullLock: {
        bold: 'Your selected ponds have been locked by another user.',
        message: 'Select other ponds or try again later.',
      },
      notGrantedLabel: 'Locked ponds by other users (will not be included)',
      grantedLabel: 'Destination pond(s)',
    },
    selectFarm: 'Velg gård',
    pondName: 'Pond name',
    timer: {
      reset: 'Tilbakestill økt',
      error: 'Økten vår har utløpt på grunn av inaktivitet. Arbeidet ditt er ikke lagret',
      expire: 'This session will expire in {time}',
    },
    listSelectedPonds: {
      registrationDate: 'Dato for registrering',
      selectedPonds: 'Utvalgt dammer',
      list: {
        name: 'Navn',
        zone: 'Sone',
        status: 'Status',
        activeDays: 'Aktive dagar',
      },
    },
    summary: 'Sammendrag',
    selectedFarm: 'Utvalgt gård: ',
    selectedDate: 'Valgt registreringsdato',
    farmOverview: {
      title: 'Gård oversikt',
      farms: {
        name: 'Gård',
        numberOfPonds: 'Antall dammer',
        lastRegistrationDate: 'Siste registreringsdato',
      },
      duplicateRegistration: 'This event is already registered on {date} for: {ponds}. Please check to avoid entering a duplicate.',
      list: {
        name: 'Navn',
        zone: 'Sone',
        active: 'Active',
        days: 'Antall dagar',
        noShrimps: 'Antall reker',
        biomass: 'Biomas ({type})',
        meanWeight: 'Middelvekt (g)',
      },
      buttons: {
        newStock: 'Legg til lager',
        newTransfer: 'Legg til overføring',
        newHarvest: 'Legg til avling',
        newFeeding: 'Legg til fôring',
        sampling: 'Legg til ny gjennomsnittlig vektprøve',
        waterQuality: 'Vannkvalitet',
        newTreatment: 'Legg til behandling',
        previousDay: 'Tidligere dag',
        nextDay: 'Neste dag',
      },
      filters: {
        showActive: 'Vis aktive dammer',
        showInactive: 'Vis inaktive dammer',
        registrationDate: 'Dato for registrering',
        zone: 'Filter på zone',
        selectAll: 'Velg alle',
        poundsOrKg: 'Pounds (lbs) / kg',
        pondType: 'Damtyp',
        pondTypes: {
          Production: 'Production',
          Raceway: 'Raceway',
          Nursery: 'Nursery',
        },
      },
      feeding: {
        add: {
          destinationPond: 'Destinasjon dam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende biomas {type}',
          feed: 'Fôr',
          feederBrand: 'Matersøk',
          feedQuantity: 'Fôrmengde ({type})',
          summary: 'Sammendrag',
          switchLabel: 'Pounds (lbs) / Kg',
        },
        edit: {
          destinationPond: 'Destinasjon dam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'No. Shrimps',
          meanWeight: 'Mean weight (g)',
          biomass: 'Biomass ({type})',
          feed: 'Fôr',
          feederBrand: 'Matersøk',
          feedQuantity: 'Fôrmengde ({type})',
          summary: 'Sammendrag',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      stocking: {
        deliveredTrackingCode: 'Levert referansekode',
        genetics: 'Genetics',
        larvaCost: 'Larva costs/1000',
        maturation: 'Maturation/reproducers',
        nauplius: 'Nauplius producers',
        laboratoryPl: 'Laboratory PL',
        grid: {
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          startMeanWeight: 'Startmiddelvekt (g)',
          targetMeanWeight: 'Målmiddelvekt (g)',
          startQuantity: 'Start mengde',
          targetQuantity: 'Målmengde',
          targetEndDate: 'Målsluttdato (dagar)',
          biomass: 'Biomasse (kg)',
          survivalRate: 'Overlevelsesrate',
          summary: 'Sammendrag',
        },
      },
      harvest: {
        processorReference: 'Prosessorreferanse',
        add: {
          harvestPond: 'Høste Pondce',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende Biomas {type}',
          harvestNumber: 'Innhøstingsnummer',
          harvestMw: 'Harvest Mw (g)',
          harvestBm: 'Høst biomas {type}',
          partialHarvest: 'Delvis høsting',
          remainingNumber: 'Gjenstående nummer',
          remainingMw: 'Gjenværende mw (g)',
          remainingBm: 'gjenværende biomas {type}',
          summary: 'Sammendrag',
          switchLabel: 'Pounds (lbs) / Kg',
        },
        edit: {
          harvestPond: 'Høste Pondce',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende Biomas {type}',
          harvestNumber: 'Innhøstingsnummer',
          harvestMw: 'Harvest Mw (g)',
          harvestBm: 'Høst biomas {type}',
          partialHarvest: 'Delvis høsting',
          remainingNumber: 'Gjenstående nummer',
          remainingMw: 'Gjenværende mw (g)',
          remainingBm: 'gjenværende biomas {type}',
          summary: 'Sammendrag',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      sampling: {
        add: {
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende Biomas (kg)',
          newMeanWeight: 'Ny Mw (g)',
          survivalRate: 'Overlevelsesrate',
          summary: 'Sammendrag',
        },
        edit: {
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'No. Shrimps',
          meanWeight: 'Nåværende middelvekt (g)',
          biomass: 'Nåværende Biomas (kg)',
          newMeanWeight: 'Ny middelvekt (g)',
          survivalRate: 'Overlevelsesrate',
          summary: 'Sammendrag',
        },
      },
      transfer: {
        title: 'Transfer Pond',
        sourcePond: 'Kildedam',
        destinationPonds: 'Destination ponds',
        confirmTransfer: 'Bekreft overføring',
        partialTransferError:
          'Tallet i kildedammen tilsvarer ikke tallet i destinasjonsdammen(e). Du kan velge delvis overføring ovenfor.',
        errorMessage: 'Values must be greater than 0',
        transferNumberError: 'Transfer cannot be greater than current number',
        selectDestinationPond: 'Velg Destinasjonsdam',
        fields: {
          selectedDate: 'Dato for registrering',
          sourcePond: 'Source pond',
          cycleName: 'Cycle name',
          destinationPond: 'Destinasjonsdam',
          referenceCode: 'Levert referansekode',
          partialTransfer: 'Delvis overføring',
        },
        list: {
          name: 'Navn',
          zone: 'Sone',
          status: 'Status',
          days: 'Antall dagar',
          noShrimps: 'Antall reker',
          biomass: 'Biomas (kg)',
          meanWeight: 'Middelvekt (g)',
        },
        listHeaders: {
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          meanWeight: 'Middelvekt (g)',
          biomass: 'Biomasse (kg)',
          harvestDate: 'Målsluttdato',
          survivalRate: 'Overlevelsesrate',
        },
        add: {
          source: {
            sourcePond: 'Kildedam',
            cycleName: 'Syklusnavn',
            currentNumberAdd: 'Nåværende nummer (før overføring)',
            currentMw: 'Nåværende Mw (g)',
            currentBm: 'Nåværende Biomas (kg)',
            newCycleName: 'Nytt Syklusnavn',
            transferNumber: 'Overføringsnummer',
            remainingQty: 'Resterende antall',
            remainingMw: 'Middelvekt (g)',
            remainingBm: 'Resterende bm (kg)',
          },
          destination: {
            currentQty: 'Nåværende nummer (før overføring)',
            destinationPond: 'Destinasjonsdam',
            cycleName: 'Syklusnavn',
            transferQty: 'Overføringsnummer',
            transferMw: 'Middelvekt (g)',
            transferBm: 'Biomasse (kg)',
            summary: 'Sammendrag',
          },
        },
        edit: {
          source: {
            sourcePond: 'Kildedam',
            partialTransfer: 'Delvis overføring',
            fullTransfer: 'Full overføring',
            cycleName: 'Syklusnavn',
            currentQty: 'No. Shrimps (før overføring)',
            currentMw: 'Middelvekt(g) (før overføring)',
            currentBm: 'Biomas (kg) (før overføring)',
            newCycleName: 'Nytt Syklusnavn',
            transferNumber: 'Overføringsnummer',
            remainingQty: 'Resterende antall',
            remainingMw: 'Middelvekt (g)',
            remainingBm: 'Resterende bm (kg)',
          },
          destination: {
            currentQty: 'Nåværende nummer (før overføring)',
            destinationPond: 'Destinasjonsdam',
            cycleName: 'Syklusnavn',
            transferQty: 'Overføringsnummer',
            transferMw: 'Middelvekt (g)',
            transferBm: 'Biomasse (kg)',
            summary: 'Sammendrag',
          },
        },
      },
      waterQuality: {
        registrationDate: 'Dato for registrering',
        destinationPonds: 'Destinasjonsdammer',
        types: {
          1: 'Dissolved oxygen',
          2: 'Turbidity',
          3: 'Water temperature',
          4: 'Salinity',
          5: 'pH',
        },
        add: {
          summary: 'Sammendrag',
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende Biomas (kg)',
          waterQualityType: 'Kvalitetstype',
          value: 'Verdi',
        },
        edit: {
          summary: 'Sammendrag',
          destinationPond: 'Destinasjonsdam',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'No. Shrimps',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende Biomas (kg)',
          waterQualityType: 'Kvalitetstype',
          value: 'Verdi',
        },
        list: {
          name: 'Navn',
          zone: 'Sone',
          status: 'Status',
          days: 'Antall dagar',
        },
      },
      treatment: {
        Search: {
          NoResults: 'Ingen resultater',
        },
        Buttons: {
          Confirm: 'Bekrefte',
          ConfirmTreatment: 'Bekreft behandling',
        },
        add: {
          destinationPond: 'Destinasjonsdammer',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'Nåværende nummer',
          meanWeight: 'Nåværende Mw (g)',
          biomass: 'Nåværende biomas (kg)',
          treatmentType: 'Behandlingstype',
          amount: 'Beløp',
          summary: 'Sammendrag',
        },
        edit: {
          destinationPond: 'Destinasjonsdammer',
          cycleName: 'Syklusnavn',
          zone: 'Sone',
          number: 'No. Shrimps',
          meanWeight: 'Mean weight (g)',
          biomass: 'Biomas (kg)',
          treatmentType: 'Behandlingstype',
          amount: 'Beløp',
          summary: 'Sammendrag',
        },
      },
    },
    registrationLog: {
      title: 'Registreringslogg',
      notFoundMessage: 'Det er ingen registreringer funnet. Prøv en annen dato eller registreringstype.',
      filters: {
        fromDate: 'Fra dato',
        toDate: 'Til dato',
        registrationType: 'Registreringstype',
        showUserRegistrations: 'Vis bare bruker-en min',
        hideEmptyDays: 'Skjul tomme dager',
      },
      list: {
        registrationDate: 'Dato for registrering',
        logID: 'Log ID',
        eventNumber: 'Hendelsesnummer',
        registrationType: 'Registreringstype',
        email: 'e-post',
        dateCreated: 'Dato opprettet',
      },
      registrationTypes: {
        stocking: 'Startdato',
        transfer: 'Overføre',
        harvest: 'Innhøsting',
        feeding: 'Fôring',
        treatment: 'Behandling',
        waterQualitySample: 'Vannkvalitetsprøve',
        meanweightSample: 'Gjennomsnittlig vektprøve',
        mortality: 'Dødelighet',
        feederChange: 'Feeder change',
        aeratorChange: 'Aerator change',
      },
    },
    farmSetup: {
      title: 'Farm Setup',
      tooltip: {
        feeders: 'feeders',
        aerators: 'aerators',
        feedersCapacity: 'feed capacity',
        aeratorsSupported: 'of biomass supported',
      },
      list: {
        name: 'Name',
        zone: 'Zone',
        active: 'Active',
        days: 'No. Days',
        noShrimps: 'No. Shrimps',
        biomass: 'Biomass ({type})',
        avgWeight: 'Avg. Weight (g)',
        feeders: 'Feeders',
        aerators: 'Aerators',
        aeratorSupportedBiomass: 'Aerator sup. biomass ({type})',
        feederSupportedBiomass: 'Feeder sup. biomass ({type})',
      },
      buttons: {
        previousDay: 'Previous Day',
        nextDay: 'Next Day',
        manageAerators: 'Manage Aerators',
        manageFeeders: 'Manage Feeders',
        done: 'Done',
      },
      dialogs: {
        feeders: {
          feedersCapacity: 'of current pond feed demand supported',
          name: 'Name',
          brand: 'Brand',
          noUnits: 'No. of units',
          type: 'Type',
          storageCapacity: 'Storage cap. kg',
          feedingCapacity: 'Feeding cap. kg',
          currentCapacity: 'Current pond biomass: {biomass} kg',
          feeder: 'Feeder',
          addFeeders: 'Add feeder to pond',
          added: '(Added)',
          close: 'Close',
        },
        aerators: {
          aeratorsSupported: 'of current pond biomass supported',
          name: 'Name',
          brand: 'Brand',
          noUnits: 'No. of units',
          type: 'Type',
          horsePower: 'Horsepower / unit',
          supportedBiomass: 'Biomass support / unit',
          currentCapacity: 'Current pond biomass: {biomass} kg',
          aerator: 'Aerator',
          quantity: 'Quantity',
          addAerators: 'Add aerator to pond',
          added: '(Added)',
          close: 'Close',
        },
        registrationDate: 'Registration date',
        addAeratorToPond: 'Add',
        addFeederToPond: 'Add',
      },
      filters: {
        showActive: 'Show active ponds',
        showInactive: 'Show inactive ponds',
        registrationDate: 'Registration date',
        zone: 'Filter on zone',
        selectAll: 'Select all',
        pondType: 'Pond Type',
        poundsOrKg: 'Pounds (lbs) / kg',
        pondTypes: {
          Production: 'Production',
          Raceway: 'Raceway',
          Nursery: 'Nursery',
        },
      },
    },
  },
  selfService: {
    title: 'Selvbetjening',
    feedCatalog: {
      createNewFeed: 'Legg til feed',
      title: 'Fôrkatalog',
      filters: {
        showActive: 'Vis aktive innmatinger',
        showInactive: 'Vis inaktive feeder',
      },
      types: {
        extruded: 'Extruded',
        crumble: 'Crumble',
        pellet: 'Pellet',
        liquid: 'Liquid',
        soy: 'Soy',
        regular: 'Regular',
        functional: 'Functional',
      },
      list: {
        feedBrandId: 'Fôrmerke ID',
        feedType: 'Fôrtype',
        feedSubType: 'Undertype for feed',
        name: 'Navn',
        size: 'Størrelse',
        price: 'Pris',
        createdBy: 'Laget av',
        active: 'Aktiv',
        edit: 'Redigere',
      },
      createFeedCatalog: {
        dialog: {
          title: 'Oppdater feed',
          button: 'Lagre',
          inputName: 'Inndata Navn',
          selectFeedBrand: 'Velg fôrmerke',
          selectFeedType: 'Velg feedtype',
          selectFeedSubType: 'Velg undertype for feed',
          inputSize: 'Inndata Størrelse',
          inputPrice: 'Inngangspris',
          inactive: 'Inaktiv feed',
          inputCode: 'kode (optional)',
          duplicatedCode: 'A feed with the code you entered already exists',
        },
      },
      editFeedCatalog: {
        dialog: {
          title: 'Oppdater feed',
          button: 'Lagre',
          inputName: 'Inndata Navn',
          selectFeedBrand: 'Velg fôrmerke',
          selectFeedType: 'Velg feedtype',
          selectFeedSubType: 'Velg undertype for feed',
          inputSize: 'Inndata Størrelse',
          inputPrice: 'Inngangspris',
          inactive: 'Inaktiv feed',
          inputCode: 'kode (optional)',
          duplicatedCode: 'A feed with the code you entered already exists',
        },
      },
    },
    treatmentCatalog: {
      title: 'Behandlingskatalog',
      filters: {
        showActive: 'Vis aktive behandlinger',
        showInactive: 'Vis inaktive behandlinger',
      },
      list: {
        code: 'Kode',
        type: 'Type',
        brand: 'Merke',
        name: 'Navn',
        price: 'Pris',
        treatmentCategory: 'Behandling Cat. ID',
        createdBy: 'Laget av',
        active: 'Aktiv',
        edit: 'Redigere',
      },
      types: {
        liquid: 'Liquid',
        powder: 'Powder',
        solid: 'Solid',
        chemical: 'Chemical',
        fertilizer: 'Fertilizer',
        probiotic: 'Probiotic',
        feedAddative: 'Feed Addative',
        antibiotic: 'Antibiotic',
      },
      createTreatmentDialog: {
        dialog: {
          title: 'Opprette ny behandling',
          button: 'Lagre',
          code: 'Kode',
          type: 'Velg behandlingstype',
          brand: 'Merke',
          name: 'Navn',
          price: 'Pris',
          treatmentCategory: 'Velg behandlingskategori',
          inactive: 'Inaktiver behandling',
          success: 'Behandling registrert',
          duplicatedCode: 'A treatment with the code you entered already exists',
        },
      },
      editTreatmentCatalog: {
        dialog: {
          title: 'Oppdater behandling',
          button: 'Lagre',
          code: 'Kode',
          type: 'Type',
          brand: 'Merke',
          name: 'Navn',
          price: 'Pris',
          treatmentCategory: 'Behandling cat. ID',
          inactive: 'Inaktiver behandling',
          duplicatedCode: 'A treatment with the code you entered already exists',
        },
      },
    },
    aerators: {
      title: 'Aerators',
      filters: {
        showActive: 'Show active aerators',
        showInactive: 'Show inactive aerators',
      },
      list: {
        name: 'Name',
        brand: 'Brand',
        type: 'Type',
        horsepower: 'Horsepower',
        biomassSupported: 'Supported Biomass (kg)',
        active: 'Active',
        edit: 'Edit',
      },
      types: {
        electric: 'Electric',
        diesel: 'Diesel',
        paddleWheel: 'Paddle Wheel',
        injection: 'Injection',
        diffusion: 'Diffusion',
      },
      createAerator: {
        btnTitle: 'Create aerator',
        dialog: {
          title: 'Create new aerator',
          name: 'Name',
          brand: 'Brand (optional)',
          type: 'Type',
          subType: 'Sub-type',
          horsepower: 'Horsepower',
          biomassSupported: 'Supported biomass',
          button: 'Save',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      updateAerator: {
        dialog: {
          title: 'Update aerator',
          name: 'Name',
          brand: 'Brand (optional)',
          type: 'Type',
          subType: 'Sub-type',
          horsepower: 'Horsepower',
          biomassSupported: 'Supported biomass',
          inactive: 'Inactive Aerator',
          button: 'Save',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
    },
    feeders: {
      title: 'Feeders',
      filters: {
        showActive: 'Show active feeders',
        showInactive: 'Show inactive feeders',
      },
      list: {
        name: 'Name',
        brand: 'Brand',
        storageCapacity: 'Storage cap.',
        supportedBiomass: 'Supported biomass',
        active: 'Active',
        edit: 'Edit',
        kgFeeder: 'kg/feeder',
      },
      createFeeder: {
        btnTitle: 'Create feeder',
        dialog: {
          title: 'Create new feeder',
          name: 'Name',
          brand: 'Brand',
          storageCapacity: 'Storage capacity',
          supportedBiomass: 'Supported biomass',
          button: 'Save',
          endAdornment: '{unit}/feeder',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
      updateFeeder: {
        dialog: {
          title: 'Update feeder',
          name: 'Name',
          brand: 'Brand',
          storageCapacity: 'Storage capacity',
          supportedBiomass: 'Supported biomass',
          inactive: 'Inactive Feeder',
          button: 'Save',
          endAdornment: '{unit}/feeder',
          switchLabel: 'Pounds (lbs) / Kg',
        },
      },
    },
  },
  form: {
    errors: 'Feil',
    rules: {
      required: 'Dette feltet er påkrevd',
      moreThanZero: 'Verdien må være høyere enn 0',
      minValue: 'Verdien må være høyere enn {min}',
      maxValue: 'Verdien må være lavere enn {max}',
      between: 'Verdien må være mellom {lower} og {upper}',
      positive: 'Verdien kan ikke være negativ',
      packaging: 'Ingen sekkestørrelse tilgjengelig',
      multiple: 'Kvantum må ta hensyn til {packaging}',
      largerThen: 'Verdien er større enn {field}',
      duplication: 'En identisk bestilling eksisterer',
      errorMessage: 'This value needs to be greater then 0',
      invalidValue: 'This value is not valid',
    },
    buttons: {
      edit: 'Rediger rapport',
      nextFish: 'Neste fisk',
      cancel: 'Avbryt',
      confirm: 'Bekrefte',
      downloadFile: 'Nedlasting',
      chooseFile: 'Choose file',
    },
    fileUpload: {
      heading: 'Eksporter informasjon',
      listRow: {
        fileName: 'Filnavn',
        source: 'Kilde',
        destination: 'Mål',
        version: 'Version',
        exportDate: 'Export Date',
        periodStart: 'Periodestart',
        periodEnd: 'Periodeslutt',
        companies: 'Bedrifter',
      },
      options: {
        field: 'Felt',
        value: 'Verdi',
        siteName: 'Lokalitet',
        lastDate: 'Siste dato for registrering',
        latitude: 'Breddegrad',
        longitude: 'Lengdegrad',
      },
    },
  },
  snackbar: {
    success: {
      default: 'Success',
      calc: 'Kjør kalibrering',
      scenarioRunStarted: 'Scenario run started.',
      scenarioResultsReady: 'Scenario results are ready.',
      viewResults: 'View results',
    },
    errors: {
      default: 'Det har oppstått en feil',
    },
    warning: {
      default: 'Advarsel',
    },
  },
  dialog: {
    delete: {
      title: 'Er du sikker?',
    },
  },
  benchmarkAnalytics: {
    growth: 'Vekst',
    placeholderOne: 'Plassholder 1',
    placeholderTwo: 'Plassholder 2',
    growthPage: {
      filters: {
        day: 'Dag',
        week: 'Uke',
        month: 'Måned',
        quarter: 'Kvartal',
        fullCycle: 'Hel syklus',
        finalStage: 'Sluttfase',
        fromDate: 'Fra dato',
        toDate: 'Til dato',
        clear: 'Nullstill',
        reset: 'Tilbakestill',
        addFarm: 'Legg til et anlegg for å sammenligne',
        farmsSelected: '{count} av {total} valgt',
        farmsAll: 'Alle ({total})',
        selectAll: 'Velg alle',
        groupingLabel: 'Tidsgruppering',
        variantLabel: 'Vekstvariant',
      },
      caption: 'Marked: {market} daglige punkter | Selskap: {company}',
      kpi: {
        periods: 'Perioder',
        periodsCaption: '{count} perioder ({grouping}) i utvalget',
        companyAvg: 'Selskapets snittvekst (g/dag)',
        marketAvg: 'Snittvekst i {market}-markedet (g/dag)',
        weightedOverall: 'vektet totalt',
        periodsMatched: '{count} perioder med treff',
        overallDelta: 'Total Δ mot markedet',
        aboveMarket: 'over markedet',
        belowMarket: 'under markedet',
        equalMarket: 'lik markedet',
      },
      chart: {
        title: 'Vekst ({variant}) mot markedet',
        yAxis: 'Vekstrate (g/dag)',
        xAxis: 'Periode',
        thisCompany: 'Dette selskapet',
        marketAvg: '{market} markedssnitt',
        noData: '(ingen data)',
        allHidden: 'Alle serier er skjult.',
        empty: 'Ingen data for dette utvalget.',
        error: 'Vekstdata kunne ikke lastes.',
        retry: 'Prøv igjen',
      },
      table: {
        title: 'Vekstbenchmark — {variant}',
        period: 'Periode',
        company: 'Selskapets vekst (g/dag)',
        market: 'Markedssnitt (g/dag)',
        farmGrowth: 'Vekst {farm}',
        delta: 'Δ mot markedet',
        periodsFooter: '{count} perioder',
        scrollLeft: 'Rull én kolonne til venstre',
        scrollRight: 'Rull én kolonne til høyre',
      },
      unit: {
        gPerDay: 'g/dag',
      },
    },
  },
  sidebar: {
    overview: 'Oversikt',
    deliveryBoard: 'Leveranseoversikt',
    orderFeed: 'Fôrbestilling ',
    fishCheck: 'Fish Check',
    planningPrognosis: 'Plan & Prognose',
    reports: 'Rapporter',
    seaCloudFileUpload: 'SeaCloud Filopplasting',
    bluViuNutrition: 'bluViu Nutrition',
    feedManagement: 'Feed Management',
    siteSettings: 'Mine lokaliteter',
    profilesStrategies: 'Profiler & Strategier',
    fileSharing: 'Filer',
    settings: 'Innstillinger',
    logout: 'Logg ut',
    productionSystems: 'Produksjonssystemer',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Selvbetjening',
    shrimpDataUpload: 'Shrimp Data Upload',

    playground: 'Playground',
  },
  footer: {
    copyright: 'Copyright © Cargill, Incorporated. Alle rettigheter forbeholdt.',
    copyrightUk: 'Copyright © 2022 Cargill, Incorporated. Alle rettigheter forbeholdes.',
    ukAddress: 'EWOS Limited. Registered Office: 7th Floor, 33 King William Street, London, EC4R 9AT',
    ukRegister: ' Registered in England and Wales, Company No: 01635854',
  },
  MobileAppBanner: {
    title: 'Få BluViu-appen',
    description: 'Få en bedre opplevelse på telefonen med mobilappen vår.',
  },
};
